webpackJsonp([10],{

/***/ 1124:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1125:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1126:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1128:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1129:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1131:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1132:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1133:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1134:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1136:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 379,
	"./af.js": 379,
	"./ar": 386,
	"./ar-dz": 380,
	"./ar-dz.js": 380,
	"./ar-kw": 381,
	"./ar-kw.js": 381,
	"./ar-ly": 382,
	"./ar-ly.js": 382,
	"./ar-ma": 383,
	"./ar-ma.js": 383,
	"./ar-sa": 384,
	"./ar-sa.js": 384,
	"./ar-tn": 385,
	"./ar-tn.js": 385,
	"./ar.js": 386,
	"./az": 387,
	"./az.js": 387,
	"./be": 388,
	"./be.js": 388,
	"./bg": 389,
	"./bg.js": 389,
	"./bm": 390,
	"./bm.js": 390,
	"./bn": 392,
	"./bn-bd": 391,
	"./bn-bd.js": 391,
	"./bn.js": 392,
	"./bo": 393,
	"./bo.js": 393,
	"./br": 394,
	"./br.js": 394,
	"./bs": 395,
	"./bs.js": 395,
	"./ca": 396,
	"./ca.js": 396,
	"./cs": 397,
	"./cs.js": 397,
	"./cv": 398,
	"./cv.js": 398,
	"./cy": 399,
	"./cy.js": 399,
	"./da": 400,
	"./da.js": 400,
	"./de": 403,
	"./de-at": 401,
	"./de-at.js": 401,
	"./de-ch": 402,
	"./de-ch.js": 402,
	"./de.js": 403,
	"./dv": 404,
	"./dv.js": 404,
	"./el": 405,
	"./el.js": 405,
	"./en-au": 406,
	"./en-au.js": 406,
	"./en-ca": 407,
	"./en-ca.js": 407,
	"./en-gb": 408,
	"./en-gb.js": 408,
	"./en-ie": 409,
	"./en-ie.js": 409,
	"./en-il": 410,
	"./en-il.js": 410,
	"./en-in": 411,
	"./en-in.js": 411,
	"./en-nz": 412,
	"./en-nz.js": 412,
	"./en-sg": 413,
	"./en-sg.js": 413,
	"./eo": 414,
	"./eo.js": 414,
	"./es": 418,
	"./es-do": 415,
	"./es-do.js": 415,
	"./es-mx": 416,
	"./es-mx.js": 416,
	"./es-us": 417,
	"./es-us.js": 417,
	"./es.js": 418,
	"./et": 419,
	"./et.js": 419,
	"./eu": 420,
	"./eu.js": 420,
	"./fa": 421,
	"./fa.js": 421,
	"./fi": 422,
	"./fi.js": 422,
	"./fil": 423,
	"./fil.js": 423,
	"./fo": 424,
	"./fo.js": 424,
	"./fr": 427,
	"./fr-ca": 425,
	"./fr-ca.js": 425,
	"./fr-ch": 426,
	"./fr-ch.js": 426,
	"./fr.js": 427,
	"./fy": 428,
	"./fy.js": 428,
	"./ga": 429,
	"./ga.js": 429,
	"./gd": 430,
	"./gd.js": 430,
	"./gl": 431,
	"./gl.js": 431,
	"./gom-deva": 432,
	"./gom-deva.js": 432,
	"./gom-latn": 433,
	"./gom-latn.js": 433,
	"./gu": 434,
	"./gu.js": 434,
	"./he": 435,
	"./he.js": 435,
	"./hi": 436,
	"./hi.js": 436,
	"./hr": 437,
	"./hr.js": 437,
	"./hu": 438,
	"./hu.js": 438,
	"./hy-am": 439,
	"./hy-am.js": 439,
	"./id": 440,
	"./id.js": 440,
	"./is": 441,
	"./is.js": 441,
	"./it": 443,
	"./it-ch": 442,
	"./it-ch.js": 442,
	"./it.js": 443,
	"./ja": 444,
	"./ja.js": 444,
	"./jv": 445,
	"./jv.js": 445,
	"./ka": 446,
	"./ka.js": 446,
	"./kk": 447,
	"./kk.js": 447,
	"./km": 448,
	"./km.js": 448,
	"./kn": 449,
	"./kn.js": 449,
	"./ko": 450,
	"./ko.js": 450,
	"./ku": 451,
	"./ku.js": 451,
	"./ky": 452,
	"./ky.js": 452,
	"./lb": 453,
	"./lb.js": 453,
	"./lo": 454,
	"./lo.js": 454,
	"./lt": 455,
	"./lt.js": 455,
	"./lv": 456,
	"./lv.js": 456,
	"./me": 457,
	"./me.js": 457,
	"./mi": 458,
	"./mi.js": 458,
	"./mk": 459,
	"./mk.js": 459,
	"./ml": 460,
	"./ml.js": 460,
	"./mn": 461,
	"./mn.js": 461,
	"./mr": 462,
	"./mr.js": 462,
	"./ms": 464,
	"./ms-my": 463,
	"./ms-my.js": 463,
	"./ms.js": 464,
	"./mt": 465,
	"./mt.js": 465,
	"./my": 466,
	"./my.js": 466,
	"./nb": 467,
	"./nb.js": 467,
	"./ne": 468,
	"./ne.js": 468,
	"./nl": 470,
	"./nl-be": 469,
	"./nl-be.js": 469,
	"./nl.js": 470,
	"./nn": 471,
	"./nn.js": 471,
	"./oc-lnc": 472,
	"./oc-lnc.js": 472,
	"./pa-in": 473,
	"./pa-in.js": 473,
	"./pl": 474,
	"./pl.js": 474,
	"./pt": 476,
	"./pt-br": 475,
	"./pt-br.js": 475,
	"./pt.js": 476,
	"./ro": 477,
	"./ro.js": 477,
	"./ru": 478,
	"./ru.js": 478,
	"./sd": 479,
	"./sd.js": 479,
	"./se": 480,
	"./se.js": 480,
	"./si": 481,
	"./si.js": 481,
	"./sk": 482,
	"./sk.js": 482,
	"./sl": 483,
	"./sl.js": 483,
	"./sq": 484,
	"./sq.js": 484,
	"./sr": 486,
	"./sr-cyrl": 485,
	"./sr-cyrl.js": 485,
	"./sr.js": 486,
	"./ss": 487,
	"./ss.js": 487,
	"./sv": 488,
	"./sv.js": 488,
	"./sw": 489,
	"./sw.js": 489,
	"./ta": 490,
	"./ta.js": 490,
	"./te": 491,
	"./te.js": 491,
	"./tet": 492,
	"./tet.js": 492,
	"./tg": 493,
	"./tg.js": 493,
	"./th": 494,
	"./th.js": 494,
	"./tk": 495,
	"./tk.js": 495,
	"./tl-ph": 496,
	"./tl-ph.js": 496,
	"./tlh": 497,
	"./tlh.js": 497,
	"./tr": 498,
	"./tr.js": 498,
	"./tzl": 499,
	"./tzl.js": 499,
	"./tzm": 501,
	"./tzm-latn": 500,
	"./tzm-latn.js": 500,
	"./tzm.js": 501,
	"./ug-cn": 502,
	"./ug-cn.js": 502,
	"./uk": 503,
	"./uk.js": 503,
	"./ur": 504,
	"./ur.js": 504,
	"./uz": 506,
	"./uz-latn": 505,
	"./uz-latn.js": 505,
	"./uz.js": 506,
	"./vi": 507,
	"./vi.js": 507,
	"./x-pseudo": 508,
	"./x-pseudo.js": 508,
	"./yo": 509,
	"./yo.js": 509,
	"./zh-cn": 510,
	"./zh-cn.js": 510,
	"./zh-hk": 511,
	"./zh-hk.js": 511,
	"./zh-mo": 512,
	"./zh-mo.js": 512,
	"./zh-tw": 513,
	"./zh-tw.js": 513
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1143;

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/公众号二维码.26b7b22.jpg";

/***/ }),

/***/ 1158:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1138)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1205),
  /* scopeId */
  "data-v-4a48cbfa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1142)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1212),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1126)

var Component = __webpack_require__(10)(
  /* script */
  null,
  /* template */
  __webpack_require__(1187),
  /* scopeId */
  "data-v-0cb39190",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1127)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1189),
  /* scopeId */
  "data-v-10294a57",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1162:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1128)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1190),
  /* scopeId */
  "data-v-12e4e721",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1132)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1196),
  /* scopeId */
  "data-v-2ca35e31",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1195),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1133)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1198),
  /* scopeId */
  "data-v-324bca18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1131)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1169:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1134)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1170:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1140)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1209),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1171:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1136)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1172:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1210),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1173:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1174:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1207),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1175:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1188),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1176:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1185),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1177:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1135)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1201),
  /* scopeId */
  "data-v-434c77b8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1178:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1192),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1179:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1130)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1193),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1180:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  null,
  /* template */
  __webpack_require__(1213),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1181:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1139)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1206),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1182:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1186),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1183:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1141)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1211),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1184:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1185:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "communityNo",
      "label": "小区编号",
      "width": _vm.formcolWidth
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "communityName",
      "label": "小区名称",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省份",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "城市",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "area",
      "label": "区县",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态",
      "formatter": _vm.formatterColumn,
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysUserId",
      "label": "物业员用户名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userStatus",
      "label": "物业员状态",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1186:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "enterpriserVo",
    staticStyle: {
      "margin": "15px",
      "width": "80%",
      "min-width": "800px"
    },
    attrs: {
      "model": _vm.enterpriserVo,
      "inline": true,
      "label-width": "100px",
      "size": "mini"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称"
    }
  }, [_c('el-col', [_c('el-input', {
    staticStyle: {
      "width": "510px"
    },
    on: {
      "blur": function($event) {
        return _vm.getEnterpriseByCenterData()
      }
    },
    model: {
      value: (_vm.enterpriserVo.name),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "name", $$v)
      },
      expression: "enterpriserVo.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.legalPerson),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "legalPerson", $$v)
      },
      expression: "enterpriserVo.legalPerson"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业范围"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.businessScope),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "businessScope", $$v)
      },
      expression: "enterpriserVo.businessScope"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册地址"
    }
  }, [_c('el-col', [_c('el-input', {
    staticStyle: {
      "width": "510px"
    },
    model: {
      value: (_vm.enterpriserVo.regAddr),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "regAddr", $$v)
      },
      expression: "enterpriserVo.regAddr"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税人性质"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.taxpayerType),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "taxpayerType", $$v)
      },
      expression: "enterpriserVo.taxpayerType"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "纳税人识别号"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.taxpayerNum),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "taxpayerNum", $$v)
      },
      expression: "enterpriserVo.taxpayerNum"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.openingBank),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "openingBank", $$v)
      },
      expression: "enterpriserVo.openingBank"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行账户"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.bankAccount),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "bankAccount", $$v)
      },
      expression: "enterpriserVo.bankAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.linkMan),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "linkMan", $$v)
      },
      expression: "enterpriserVo.linkMan"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.enterpriserVo.linkPhone),
      callback: function($$v) {
        _vm.$set(_vm.enterpriserVo, "linkPhone", $$v)
      },
      expression: "enterpriserVo.linkPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1187:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 1188:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动区域"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择活动区域"
    },
    model: {
      value: (_vm.form.region),
      callback: function($$v) {
        _vm.$set(_vm.form, "region", $$v)
      },
      expression: "form.region"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "区域一",
      "value": "shanghai"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "区域二",
      "value": "beijing"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.$set(_vm.form, "date1", $$v)
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-time-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "fixed-time",
      "placeholder": "选择时间"
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.$set(_vm.form, "date2", $$v)
      },
      expression: "form.date2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "即时配送"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.delivery),
      callback: function($$v) {
        _vm.$set(_vm.form, "delivery", $$v)
      },
      expression: "form.delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动性质"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "美食/餐厅线上活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "地推活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "线下主题活动",
      "name": "type"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "单纯品牌曝光",
      "name": "type"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特殊资源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.resource),
      callback: function($$v) {
        _vm.$set(_vm.form, "resource", $$v)
      },
      expression: "form.resource"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "线上品牌商赞助"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "线下场地免费"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动形式"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("立即创建")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1189:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    class: _vm.isNotUserRequestCertificateClass
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUserRequestCertificate),
      expression: "isUserRequestCertificate"
    }],
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bold"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n      " + _vm._s(_vm.collapsed ? "" : _vm.sysName) + "\n      "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v(_vm._s(_vm.sysNo))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1155)
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("我的消息")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.updatePwd.apply(null, arguments)
      }
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUserRequestCertificate),
      expression: "isUserRequestCertificate"
    }],
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.roleData), function(item, index) {
    return [_c('el-submenu', {
      key: item.id,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.resName))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return _c('el-menu-item', {
        key: child.resPath,
        attrs: {
          "index": child.resPath
        }
      }, [_vm._v(_vm._s(child.resName))])
    })], 2)]
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUserRequestCertificate),
      expression: "isUserRequestCertificate"
    }],
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrap",
    staticStyle: {
      "background-image": "url('static/login-bg.jpg')"
    }
  }, [_c('div', {
    staticClass: "ms-login"
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("五所业务服务平台")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.data.loginName),
      callback: function($$v) {
        _vm.$set(_vm.data, "loginName", $$v)
      },
      expression: "data.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.$set(_vm.data, "password", $$v)
      },
      expression: "data.password"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "验证码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.data.picCode),
      callback: function($$v) {
        _vm.$set(_vm.data, "picCode", $$v)
      },
      expression: "data.picCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 10
    }
  }, [_c('img', {
    attrs: {
      "span": 10,
      "src": _vm.imgStr
    },
    on: {
      "click": _vm.loadImg
    }
  })])], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1191:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "esign"
  }, [_c('div', {
    staticClass: "esign-box"
  }, [_c('vue-esign', {
    ref: "esign",
    staticClass: "sign1",
    attrs: {
      "id": "esignId",
      "width": 1,
      "height": 1,
      "isCrop": _vm.isCrop,
      "lineWidth": _vm.lineWidth,
      "lineColor": _vm.lineColor,
      "bgColor": _vm.bgColor
    },
    on: {
      "update:bgColor": function($event) {
        _vm.bgColor = $event
      },
      "update:bg-color": function($event) {
        _vm.bgColor = $event
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('vue-qr', {
    ref: "qrId",
    attrs: {
      "text": _vm.text,
      "size": 200
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "padding-top": "20px",
      "font-size": "20px",
      "border": "1px solid red",
      "width": "440px",
      "height": "180px",
      "margin-left": "-10px",
      "margin-top": "18px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "id": "conf0",
      "hidden": _vm.resultImg == '',
      "src": _vm.resultImg
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "45px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleGenerate
    }
  }, [_vm._v(" 确认签名 ")]), _c('br'), _c('br')], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "padding-top": "20px",
      "font-size": "20px"
    }
  }, [_vm._v("微信"), _c('br'), _vm._v("扫一"), _c('br'), _vm._v("扫,"), _c('br'), _vm._v("关注"), _c('br'), _vm._v("公众"), _c('br'), _vm._v("号")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "200px",
      "height": "200px"
    },
    attrs: {
      "src": __webpack_require__(1156)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "padding-top": "20px",
      "font-size": "20px"
    }
  }, [_vm._v("  微信"), _c('br'), _vm._v("扫一"), _c('br'), _vm._v("扫,"), _c('br'), _vm._v("在线"), _c('br'), _vm._v("同步"), _c('br'), _vm._v("签名")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "padding-left": "10px",
      "font-size": "20px",
      "width": "400px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(" 注意：")]), _vm._v("\r\n      请在微信扫码签名前关注 \r\n       微信公众号，点击【我的】-\r\n       【客户注册】进行注册，确认\r\n       签名有效性，同时签名后可在\r\n       公众号【委托管理】【进度查询】查询委托进度\r\n       ")])
}]}

/***/ }),

/***/ 1192:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vuex 测试")]), _vm._v("\n  Clicked: " + _vm._s(_vm.getCount) + " times\n  "), _c('button', {
    on: {
      "click": _vm.increment
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.decrement
    }
  }, [_vm._v("-")])])
},staticRenderFns: []}

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "communityNo",
      "label": "小区编号",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "communityName",
      "label": "小区名称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "province",
      "label": "省份",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city",
      "label": "城市",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "area",
      "label": "区县",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "物业员用户名",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userStatus",
      "label": "物业员状态",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.totalsize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详细信息",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "小区编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.communityNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "communityNo", $$v)
      },
      expression: "form.communityNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择省份"
    },
    on: {
      "change": function($event) {
        return _vm.selectProvince(_vm.form.province)
      }
    },
    model: {
      value: (_vm.form.province),
      callback: function($$v) {
        _vm.$set(_vm.form, "province", $$v)
      },
      expression: "form.province"
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "市"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择市"
    },
    on: {
      "change": function($event) {
        return _vm.selectCity(_vm.form.city)
      }
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }, _vm._l((_vm.citys), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择区"
    },
    on: {
      "change": function($event) {
        return _vm.selectArea(_vm.form.area)
      }
    },
    model: {
      value: (_vm.form.area),
      callback: function($$v) {
        _vm.$set(_vm.form, "area", $$v)
      },
      expression: "form.area"
    }
  }, _vm._l((_vm.areas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.state),
      callback: function($$v) {
        _vm.$set(_vm.form, "state", $$v)
      },
      expression: "form.state"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "10"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "20"
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物业员用户名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.userName),
      callback: function($$v) {
        _vm.$set(_vm.form, "userName", $$v)
      },
      expression: "form.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物业员状态"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.userStatus),
      callback: function($$v) {
        _vm.$set(_vm.form, "userStatus", $$v)
      },
      expression: "form.userStatus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "10"
    }
  }, [_vm._v("正常")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "20"
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.open2()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#E6F0F2"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入报告/证书编号",
      "size": "large"
    },
    model: {
      value: (_vm.reportCodeSeach),
      callback: function($$v) {
        _vm.reportCodeSeach = $$v
      },
      expression: "reportCodeSeach"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("报告/证书编号:")])], 2), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "39%"
    },
    attrs: {
      "placeholder": "请输入验证码",
      "size": "large"
    },
    model: {
      value: (_vm.checkCodeSeach),
      callback: function($$v) {
        _vm.checkCodeSeach = $$v
      },
      expression: "checkCodeSeach"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("验证码:")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#08c",
      "font-weight": "bold"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.loadData()
      }
    },
    slot: "append"
  }, [_vm._v("查询/Search")])], 2)], 1), _vm._v(" "), (!_vm.seachShow) ? _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "border": "1px dashed #000",
      "margin-top": "40px",
      "min-width": "730px"
    },
    attrs: {
      "id": "tableID"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0%",
      "margin-top": "2%"
    },
    attrs: {
      "border": "0"
    }
  }, [(_vm.data.ReportCode != '' && _vm.data.ReportCode != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("报告/证书编号 ：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(_vm._s(_vm.data.ReportCode))])]) : _vm._e(), _vm._v(" "), (_vm.data.ReportType != '' && _vm.data.ReportType != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("报告类型 ：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.ReportType))])]) : _vm._e(), _vm._v(" "), (_vm.data.CustomerName != '' && _vm.data.CustomerName != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("客户名称 ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(" " + _vm._s(_vm.data.CustomerName) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.data.UnitAddress != '' && _vm.data.UnitAddress != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("单位地址 ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.UnitAddress))])]) : _vm._e(), _vm._v(" "), (_vm.data.SampleName != '' && _vm.data.SampleName != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("样品名称： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(" " + _vm._s(_vm.data.SampleName))])]) : _vm._e(), _vm._v(" "), (_vm.data.FuselageNumber != '' && _vm.data.FuselageNumber != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("机身/管理号：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(_vm._s(_vm.data.FuselageNumber))])]) : _vm._e(), _vm._v(" "), (_vm.data.SampleCode != '' && _vm.data.SampleCode != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("样品型号 ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.SampleCode))])]) : _vm._e(), _vm._v(" "), (_vm.data.TestBasis != '' && _vm.data.TestBasis != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("检测依据 ：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.TestBasis) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.data.Conclusion != '' && _vm.data.Conclusion != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("结论     ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.Conclusion))])]) : _vm._e(), _vm._v(" "), (_vm.data.Reviewer != '' && _vm.data.Reviewer != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("审核人： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(" " + _vm._s(_vm.data.Reviewer))])]) : _vm._e(), _vm._v(" "), (_vm.data.Issuer != '' && _vm.data.Issuer != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("签发人   ： ")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v("  " + _vm._s(_vm.data.Issuer))])]) : _vm._e(), _vm._v(" "), (_vm.data.IssueDate != '' && _vm.data.IssueDate != null) ? _c('tr', [_c('td', {
    staticClass: "tdclass"
  }, [_vm._v("签发日期 ：")]), _vm._v(" "), _c('td', {
    staticClass: "tdclass2"
  }, [_vm._v(" " + _vm._s(_vm.data.IssueDate))])]) : _vm._e()]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seachShow),
      expression: "seachShow"
    }],
    staticStyle: {
      "widht": "20px",
      "height": "1800px",
      "background-color": "#E6F0F2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n  "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.ceprei.com/assets/img/logo1-default.png",
      "alt": "Logo"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#DCDCDC",
      "padding-top": "3px",
      "padding-bottom": "1px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#E6F0F2"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "250%",
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("证书报告验证中心")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "15px",
      "color": "#97a8be"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/"
    }
  }, [_vm._v("首页")]), _vm._v(" / 证书报告验证中心 ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#E6F0F2"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://guangzhou.cyberpolice.cn/netalarm/netalarm/Welcome.jsp?bano=4401060100873",
      "data-v-4d3159fe": "",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/cyberpolice.bfb5ba4.gif",
      "border": "0",
      "data-v-4d3159fe": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  粤ICP备09030372号")]), _vm._v(" "), _c('p', [_vm._v("网站维护：020-87237193 业务联系：020-87236881")])])])
}]}

/***/ }),

/***/ 1195:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "10px",
      "width": "90%",
      "min-width": "900px"
    },
    attrs: {
      "model": _vm.form,
      "inline": true,
      "label-width": "100px",
      "size": "mini"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', [_c('strong', [_vm._v("接洽信息")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接洽人部门"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.selectGet
    },
    model: {
      value: (_vm.form.financeCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "financeCode", $$v)
      },
      expression: "form.financeCode"
    }
  }, _vm._l((_vm.organizes), function(org) {
    return _c('el-option', {
      attrs: {
        "label": org.OrgName,
        "value": org.FinanceCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接洽人姓名"
    }
  }, [_c('el-col', [_c('el-input', {
    on: {
      "blur": _vm.getUsers
    },
    model: {
      value: (_vm.form.visitedPerson),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitedPerson", $$v)
      },
      expression: "form.visitedPerson"
    }
  })], 1)], 1), _vm._v(" "), (_vm.show) ? _c('el-form-item', {
    attrs: {
      "label": "电话"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.compare),
      callback: function($$v) {
        _vm.compare = $$v
      },
      expression: "compare"
    }
  }, _vm._l((_vm.userInfo), function(org) {
    return _c('el-option', {
      attrs: {
        "label": org.mobile,
        "value": org.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("访客信息")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "访客姓名"
    }
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.visitor),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitor", $$v)
      },
      expression: "form.visitor"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.visitorIdcard),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitorIdcard", $$v)
      },
      expression: "form.visitorIdcard"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.visitorPhone),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitorPhone", $$v)
      },
      expression: "form.visitorPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来访单位"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "510px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.visitorDep),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitorDep", $$v)
      },
      expression: "form.visitorDep"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约到访时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期时间",
      "disabled": _vm.ifHide,
      "picker-options": _vm.pickerOptions1
    },
    model: {
      value: (_vm.form.visitTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitTime", $$v)
      },
      expression: "form.visitTime"
    }
  })], 1), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "来访人id"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.visitPerson),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitPerson", $$v)
      },
      expression: "form.visitPerson"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "来访原因"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "825px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "disabled": _vm.ifHide
    },
    model: {
      value: (_vm.form.visitContent),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitContent", $$v)
      },
      expression: "form.visitContent"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.ifHide
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("立即创建")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1196:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1197:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "10px",
      "width": "80%",
      "min-width": "800px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "inline": true,
      "label-width": "100px",
      "size": "mini"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门",
      "prop": "visitedDep"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.getOrganize
    },
    model: {
      value: (_vm.form.visitedDep),
      callback: function($$v) {
        _vm.$set(_vm.form, "visitedDep", $$v)
      },
      expression: "form.visitedDep"
    }
  }, _vm._l((_vm.organizes), function(org) {
    return _c('el-option', {
      key: org.financeCode,
      attrs: {
        "label": org.dept,
        "value": org.financeCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "部门业务"
    }
  }, [_c('el-tag', {
    staticStyle: {
      "width": "825px",
      "height": "400px"
    },
    attrs: {
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.form.visitContent))])], 1), _c('br'), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("请选择部门")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1198:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartColumn"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartBar"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartLine"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": "chartPie"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "http://echarts.baidu.com/examples.html",
      "target": "_blank"
    }
  }, [_vm._v("more>>")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }]
  }, [_c('div', {
    attrs: {
      "id": "neirong"
    }
  }, [_c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "90px",
      "font-size": "23px",
      "color": "red"
    }
  }, [_vm._v(" \n           注：以下红色项为必填项\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "10px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v("  1. 委托人Client \n            "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "5%"
    }
  }, [_vm._v("合同编号：" + _vm._s(_vm.data.serialNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("名称Name：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("地址Address：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("联系人Contact：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientContacts),
      expression: "data.clientContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("电话Phone：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientPhone),
      expression: "data.clientPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("邮箱E-mail：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientMail),
      expression: "data.clientMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientFax),
      expression: "data.clientFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientFax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v(" 2. 生产者（制造商）Manufacturer（ \n            "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.producerName = _vm.data.clientName;
        _vm.data.producerAddr = _vm.data.clientAddr;
        _vm.data.producerContacts = _vm.data.clientContacts;
        _vm.data.producerPhone = _vm.data.clientPhone;
        _vm.data.producerMail = _vm.data.clientMail;
        _vm.data.producerFax = _vm.data.clientFax;
      }
    }
  }, [_vm._v("同委托方")]), _vm._v("\n          ）\n       ")], 1), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("名称Name： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerName),
      expression: "data.producerName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址Address："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerAddr),
      expression: "data.producerAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("联系人Contact："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerContacts),
      expression: "data.producerContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("电话Phone："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerPhone),
      expression: "data.producerPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("邮箱E-mail："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerMail),
      expression: "data.producerMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerFax),
      expression: "data.producerFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerFax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v("  3. 生产企业Factory（ \n            "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.factoryName = _vm.data.clientName;
        _vm.data.factoryAddr = _vm.data.clientAddr;
        _vm.data.factoryContacts = _vm.data.clientContacts;
        _vm.data.factoryPhone = _vm.data.clientPhone;
        _vm.data.factoryMail = _vm.data.clientMail;
        _vm.data.factoryFax = _vm.data.clientFax;
      }
    }
  }, [_vm._v("同委托方")]), _vm._v("） ")], 1), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("名称Name： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryName),
      expression: "data.factoryName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址Address："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryAddr),
      expression: "data.factoryAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("联系人Contact："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryContacts),
      expression: "data.factoryContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("电话Phone："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryPhone),
      expression: "data.factoryPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("邮箱E-mail："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryMail),
      expression: "data.factoryMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryFax),
      expression: "data.factoryFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryFax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v("  4. 代理方Agent\t ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("名称Name： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentName),
      expression: "data.agentName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址Address："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentAddr),
      expression: "data.agentAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("联系人Contact："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentContacts),
      expression: "data.agentContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("电话Phone："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentPhone),
      expression: "data.agentPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("邮箱E-mail："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentMail),
      expression: "data.agentMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentFax),
      expression: "data.agentFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentFax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v("  5. 交费方Payer（\n             "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.payerName = _vm.data.clientName;
        _vm.data.payerAddr = _vm.data.clientAddr;
        _vm.data.payerContacts = _vm.data.clientContacts;
        _vm.data.payerPhone = _vm.data.clientPhone;
        _vm.data.payerMail = _vm.data.clientMail;
        _vm.data.payerFax = _vm.data.clientFax;
      }
    }
  }, [_vm._v("同委托方")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.payerName = _vm.data.producerName;
        _vm.data.payerAddr = _vm.data.producerAddr;
        _vm.data.payerContacts = _vm.data.producerContacts;
        _vm.data.payerPhone = _vm.data.producerPhone;
        _vm.data.payerMail = _vm.data.producerMail;
        _vm.data.payerFax = _vm.data.producerFax;
      }
    }
  }, [_vm._v("同生产企业")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.payerName = _vm.data.agentName;
        _vm.data.payerAddr = _vm.data.agentAddr;
        _vm.data.payerContacts = _vm.data.agentContacts;
        _vm.data.payerPhone = _vm.data.agentPhone;
        _vm.data.payerMail = _vm.data.agentMail;
        _vm.data.payerFax = _vm.data.agentFax;
      }
    }
  }, [_vm._v("同代理方")]), _vm._v("\n           ） ")], 1), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("名称Name：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerName),
      expression: "data.payerName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("地址Address：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerAddr),
      expression: "data.payerAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("联系人Contact：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerContacts),
      expression: "data.payerContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("电话Phone：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerPhone),
      expression: "data.payerPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("邮箱E-mail：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerMail),
      expression: "data.payerMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerFax),
      expression: "data.payerFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerFax", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v(" 付款方式：")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.paymentMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "paymentMethod", $$v)
      },
      expression: "data.paymentMethod"
    }
  }, [_vm._v("汇款remittance")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.paymentMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "paymentMethod", $$v)
      },
      expression: "data.paymentMethod"
    }
  }, [_vm._v("支票Check")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "3"
    },
    model: {
      value: (_vm.data.paymentMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "paymentMethod", $$v)
      },
      expression: "data.paymentMethod"
    }
  }, [_vm._v("其他Other：")])], _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.paymentMethodOrder),
      expression: "data.paymentMethodOrder"
    }],
    style: (_vm.inputStyle),
    attrs: {
      "size": "10",
      "readonly": (_vm.isRedeoly || _vm.data.paymentMethod !== '3')
    },
    domProps: {
      "value": (_vm.data.paymentMethodOrder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "paymentMethodOrder", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color"
  }, [_vm._v(" 收到《收费通知单》在 "), _c('el-date-picker', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        _vm.data.payDate = _vm.initTime(_vm.data.payDate)
      }
    },
    model: {
      value: (_vm.data.payDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "payDate", $$v)
      },
      expression: "data.payDate"
    }
  }), _vm._v(" 前或按合同约定时间内付款")], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "overflow": "visible"
    }
  }, [_vm._v("  6. 样品信息Sample Information  ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.data.subData.push({
          order: '',
          name: '',
          specs: '',
          trademark: '',
          number: ''
        })
      }
    }
  }, [_vm._v("添加样品信息")])], 1)]), _vm._v(" "), _vm._l((_vm.data.subData), function(item, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(" " + _vm._s(_vm.data.subData[i].order = (i + 1)) + "  ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].name),
        expression: "data.subData[i].name"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].specs),
        expression: "data.subData[i].specs"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].specs)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "specs", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].kind),
        expression: "data.subData[i].kind"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].kind)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "kind", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].describe),
        expression: "data.subData[i].describe"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].describe)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "describe", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].trademark),
        expression: "data.subData[i].trademark"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].trademark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "trademark", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].number),
        expression: "data.subData[i].number"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly,
        "placeholder": "请输入整数"
      },
      domProps: {
        "value": (_vm.data.subData[i].number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "number", $event.target.value)
        }, function($event) {
          _vm.data.subData[i].number = _vm.data.subData[i].number.replace(/[^\d]/g, '')
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('el-button', {
      attrs: {
        "disabled": _vm.isRedeoly,
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.data.subData.splice(i, 1)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("    提供的配件或资料： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.providePartsMaterial),
      expression: "data.providePartsMaterial"
    }],
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "100"
    },
    domProps: {
      "value": (_vm.data.providePartsMaterial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "providePartsMaterial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._m(7), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.simpleSubmitMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "simpleSubmitMethod", $$v)
      },
      expression: "data.simpleSubmitMethod"
    }
  }, [_vm._v("自送")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.simpleSubmitMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "simpleSubmitMethod", $$v)
      },
      expression: "data.simpleSubmitMethod"
    }
  }, [_vm._v("邮寄")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "4"
    },
    model: {
      value: (_vm.data.simpleSubmitMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "simpleSubmitMethod", $$v)
      },
      expression: "data.simpleSubmitMethod"
    }
  }, [_vm._v("现场测试，无样交接")])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible",
      "padding": "10px",
      "line-height": "35px"
    },
    attrs: {
      "colspan": "8",
      "rowspan": "2"
    }
  }, [_vm._m(8), _vm._v(" \n                  "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "6"
    },
    model: {
      value: (_vm.data.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandle", $$v)
      },
      expression: "data.sampleHandle"
    }
  }, [_vm._v("到付寄回\n                          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.sampleHandle == '6'),
      expression: "data.sampleHandle=='6'"
    }]
  }, [_vm._v("（ \n                          "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("同委托人 ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("同生产企业")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "3"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("同代理方")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "4"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("同交费方")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "5"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("其他")])], _vm._v(" "), (_vm.data.sampleHandleReturn == '5') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.sampleHandleReturnOther),
      expression: "data.sampleHandleReturnOther"
    }],
    style: (_vm.sampleHandleReturnOtherStyle),
    attrs: {
      "size": "60",
      "readonly": (_vm.isRedeoly || _vm.data.sampleHandleReturn !== '5')
    },
    domProps: {
      "value": (_vm.data.sampleHandleReturnOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "sampleHandleReturnOther", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" \n                          ）\n                          ")], 2)]), _c('br'), _vm._v("\n                         "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandle", $$v)
      },
      expression: "data.sampleHandle"
    }
  }, [_vm._v("合同完成后一个月内自取（超期视为主动弃置，按销毁处置）")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "3"
    },
    model: {
      value: (_vm.data.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandle", $$v)
      },
      expression: "data.sampleHandle"
    }
  }, [_vm._v("实验室销毁")])]], 2)]), _vm._v(" "), _c('tr')], 2)]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v(" 7. 检验检测要求Inspection and Testing Requirements\t ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('table', [_c('tr', [_vm._m(9), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "3800",
      "readonly": _vm.isRedeoly,
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: (_vm.data.basis),
      callback: function($$v) {
        _vm.$set(_vm.data, "basis", $$v)
      },
      expression: "data.basis"
    }
  })], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "3800",
      "readonly": _vm.isRedeoly,
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: (_vm.data.items),
      callback: function($$v) {
        _vm.$set(_vm.data, "items", $$v)
      },
      expression: "data.items"
    }
  })], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "3800",
      "readonly": _vm.isRedeoly,
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: (_vm.data.conditionsRequirements),
      callback: function($$v) {
        _vm.$set(_vm.data, "conditionsRequirements", $$v)
      },
      expression: "data.conditionsRequirements"
    }
  })], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("如需分包：")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.agreeSubcontract),
      callback: function($$v) {
        _vm.$set(_vm.data, "agreeSubcontract", $$v)
      },
      expression: "data.agreeSubcontract"
    }
  }, [_vm._v("同意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "0"
    },
    model: {
      value: (_vm.data.agreeSubcontract),
      callback: function($$v) {
        _vm.$set(_vm.data, "agreeSubcontract", $$v)
      },
      expression: "data.agreeSubcontract"
    }
  }, [_vm._v("不同意")])]], 2), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("该检验是否与诉讼有关：")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "0"
    },
    model: {
      value: (_vm.data.lawsuit),
      callback: function($$v) {
        _vm.$set(_vm.data, "lawsuit", $$v)
      },
      expression: "data.lawsuit"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.lawsuit),
      callback: function($$v) {
        _vm.$set(_vm.data, "lawsuit", $$v)
      },
      expression: "data.lawsuit"
    }
  }, [_vm._v(" 是（按诉讼委托流程进行）")])]], 2)]), _vm._v(" "), _c('tr', [_vm._m(12), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [(!_vm.isRedeoly) ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "350px",
      "padding": "20px",
      "text-align": "left"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://127.0.0.1/posts/",
      "on-remove": _vm.removeFile,
      "multiple": "",
      "before-upload": _vm.beforeAvatarUpload,
      "http-request": _vm.upload,
      "limit": 10
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("选取文件")]), _c('br')], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "padding": "20px",
      "text-align": "left",
      "width": "90%"
    }
  }, _vm._l((_vm.data.attachMent), function(item, i) {
    return _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type !== 'delete'),
        expression: "item.type!=='delete'"
      }],
      key: i,
      staticClass: "el-upload-list__item-name",
      staticStyle: {
        "font-size": "15px",
        "padding-top": "0px",
        "float": "left"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "300px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      }
    }, [_c('span', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.fileName,
        "placement": "bottom"
      }
    }, [_c('i', {
      staticClass: "el-icon-document",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(" " + _vm._s(item.fileName))])])], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": "20px"
      }
    }, [_c('span', [_c('a', {
      attrs: {
        "href": "https://fw.ceprei.com/service/conSgin/downFile?fileId=" + item.fileId + "&fileName=" + item.fileName
      }
    }, [_c('i', {
      staticClass: "el-icon-download",
      staticStyle: {
        "color": "#32cd32"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": "20px"
      }
    }, [(!_vm.isRedeoly) ? _c('span', [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(item)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close",
      staticStyle: {
        "color": "red"
      }
    })])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('tr')])])]), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "float": "right",
      "margin-right": "14.6%"
    }
  }, [_vm._v("\n        8. 报告要求Report Requirements\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('table', [_c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "1"
    }
  }, [
    [_c('el-checkbox-group', {
      attrs: {
        "disabled": _vm.isRedeoly
      },
      model: {
        value: (_vm.data.reportType),
        callback: function($$v) {
          _vm.$set(_vm.data, "reportType", $$v)
        },
        expression: "data.reportType"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("中文")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "2"
      }
    }, [_vm._v("英文（加收费用）")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "4"
      }
    }, [_vm._v("不出报告")])], 1)]
  ], 2), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "1"
    }
  }, [
    [_c('el-checkbox-group', {
      attrs: {
        "disabled": _vm.isRedeoly
      },
      model: {
        value: (_vm.data.reportForm),
        callback: function($$v) {
          _vm.$set(_vm.data, "reportForm", $$v)
        },
        expression: "data.reportForm"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("电子版（默认）")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "2"
      }
    }, [_vm._v("纸质版，需额外收取费用(自取)")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "3"
      }
    }, [_vm._v("纸质版，需额外收取费用(快递) ")])], 1)]
  ], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_vm._v("报告标识：\n                ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [
    [_c('el-checkbox-group', {
      attrs: {
        "disabled": _vm.isRedeoly
      },
      model: {
        value: (_vm.data.cmaCnas),
        callback: function($$v) {
          _vm.$set(_vm.data, "cmaCnas", $$v)
        },
        expression: "data.cmaCnas"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "CNAS"
      }
    }, [_vm._v("CNAS")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "无"
      }
    }, [_vm._v("无")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "其他"
      }
    }, [_vm._v("其他")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.data.cmaCnas.includes('其他')),
        expression: "data.cmaCnas.includes('其他')"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.data.cmaCnasOther),
        expression: "data.cmaCnasOther"
      }],
      staticStyle: {
        "border-bottom": "solid red",
        "height": "20px",
        "width": "130px"
      },
      attrs: {
        "size": "60",
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.cmaCnasOther)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "cmaCnasOther", $event.target.value)
        }
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_vm._v("服务要求：\n                 \n                ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [
    [_c('el-radio', {
      attrs: {
        "disabled": _vm.isRedeoly,
        "label": "1"
      },
      model: {
        value: (_vm.data.serviceRequitements),
        callback: function($$v) {
          _vm.$set(_vm.data, "serviceRequitements", $$v)
        },
        expression: "data.serviceRequitements"
      }
    }, [_vm._v("正常（默认）")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "disabled": _vm.isRedeoly,
        "label": "2"
      },
      model: {
        value: (_vm.data.serviceRequitements),
        callback: function($$v) {
          _vm.$set(_vm.data, "serviceRequitements", $$v)
        },
        expression: "data.serviceRequitements"
      }
    }, [_vm._v("加急（需额外收取费用）")])]
  ], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("如对报告有其他要求，请说明：\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.reportRemark),
      expression: "data.reportRemark"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.reportRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "reportRemark", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible",
      "line-height": "35px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("报告接收方  ")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.reportReceiving),
      callback: function($$v) {
        _vm.$set(_vm.data, "reportReceiving", $$v)
      },
      expression: "data.reportReceiving"
    }
  }, [_vm._v("同委托人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.reportReceiving),
      callback: function($$v) {
        _vm.$set(_vm.data, "reportReceiving", $$v)
      },
      expression: "data.reportReceiving"
    }
  }, [_vm._v("同代理方")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "3"
    },
    model: {
      value: (_vm.data.reportReceiving),
      callback: function($$v) {
        _vm.$set(_vm.data, "reportReceiving", $$v)
      },
      expression: "data.reportReceiving"
    }
  }, [_vm._v("同交费方")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "4"
    },
    model: {
      value: (_vm.data.reportReceiving),
      callback: function($$v) {
        _vm.$set(_vm.data, "reportReceiving", $$v)
      },
      expression: "data.reportReceiving"
    }
  }, [_vm._v("不同于以上,请提供")])], _vm._v(" "), (_vm.data.reportReceiving == '4') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.reportReceivingOther),
      expression: "data.reportReceivingOther"
    }],
    style: (_vm.reportReceivingOtherStyle),
    attrs: {
      "size": "60",
      "readonly": (_vm.isRedeoly || _vm.data.reportReceiving !== '4')
    },
    domProps: {
      "value": (_vm.data.reportReceivingOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "reportReceivingOther", $event.target.value)
      }
    }
  }) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px"
    }
  }, [_vm._v("\n        9. 通用条款General Conditions\n        ")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('table', [_c('tr', [_vm._m(16), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40%",
      "border-right": "0px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.signer),
      expression: "data.signer"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "readonly": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit'
    },
    domProps: {
      "value": (_vm.data.signer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "signer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40%",
      "border-right": "0px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("工业和信息化部电子第五研究所/中国赛宝实验室")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "3%"
    },
    attrs: {
      "colspan": "1"
    },
    on: {
      "click": function($event) {
        _vm.imgDialog = !(_vm.isRedeoly && _vm.data.signatureType !== 'seeEdit');
      }
    }
  }, [_vm._m(18)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    },
    on: {
      "click": function($event) {
        _vm.imgDialog = !(_vm.isRedeoly && _vm.data.signatureType !== 'seeEdit');
      }
    }
  }, [(_vm.data.signaturelink === '') ? _c('span', {
    staticStyle: {
      "color": "#CACACD"
    }
  }, [_vm._v("请填写委托人、代理方，需要使用微信扫一扫签名(请点击此处)")]) : _vm._e(), _vm._v(" "), (_vm.data.signaturelink) ? _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "45px"
    },
    attrs: {
      "src": _vm.data.signaturelink
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [(_vm.data.authorizerLink === '' || _vm.data.authorizerLink === null) ? _c('span', [_vm._v(_vm._s(_vm.data.authorizer))]) : _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "45px"
    },
    attrs: {
      "src": _vm.data.authorizerLink
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(20), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.signaturetime))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("日   期/Date：")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.authorizationTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "margin-top": "40px",
      "font-size": "30px",
      "padding-left": "40%"
    }
  }, [_vm._v("\n          检验检测委托书填写说明\n        ")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "divcenter"
  }, [_c('el-dialog', {
    attrs: {
      "title": "授权人签名",
      "visible": _vm.imgDialog,
      "width": "900px",
      "lock-scroll": false
    },
    on: {
      "update:visible": function($event) {
        _vm.imgDialog = $event
      }
    }
  }, [_c('esign', {
    attrs: {
      "token": _vm.data.timeStamp + _vm.data.conId,
      "imgDialog": _vm.imgDialog
    },
    on: {
      "callback": _vm.receiveSignature
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "ont-size": "14px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1000px",
      "min-width": "1000px",
      "margin": "0 auto",
      "font-size": "23px",
      "margin-top": "10px",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v("工业和信息化部电子第五研究所/中国赛宝实验室")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("检验检测委托书")]), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-40px",
      "margin-right": "150px"
    },
    style: (_vm.data.signatureType === "see" ? "display:block" : "display:none")
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fw.ceprei.com/service/conSgin/downPDF?timeStamp=" + _vm.data.timeStamp + "&conId=" + _vm.data.conId + "&fileName=" + _vm.data.serialNumber + ".pdf"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(" 下载PDF")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-40px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sava('暂存');
      }
    }
  }, [_vm._v(" 暂存 ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "-150px",
      "margin-top": "-40px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit('提交');
      }
    }
  }, [_vm._v(" 提交 ")])], 1), _vm._v(" "), _vm._m(23)])]), _vm._v(" "), _vm._m(24)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("序号"), _c('br'), _vm._v("Serial Number ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(" 样品名称"), _c('br'), _vm._v("Product")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("样品型号"), _c('br'), _vm._v("Model No. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "width": "13%"
    }
  }, [_vm._v(" 样品规格"), _c('br'), _vm._v("Specification ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("样品描述"), _c('br'), _vm._v("Description ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(" 商标"), _c('br'), _vm._v("Trademark")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(" 数量"), _c('br'), _vm._v("Quantity")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("   "), _c('span', {
    staticClass: "color"
  }, [_vm._v(" 样品寄送方式： ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "red"
    }
  }, [_vm._v("    试验后样品处理（如不勾选，默认销毁）："), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "rowspan": "2",
      "width": "40%"
    }
  }, [_vm._v("检验检测依据"), _c('br'), _vm._v(" Testing Basis")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("检验检测项目"), _c('br'), _vm._v(" Test Items")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("检验检测条件及要求 "), _c('br'), _vm._v("Technical Conditions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("附件("), _c('span', {
    staticStyle: {
      "font-size": "13px",
      "color": "red",
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v(":重名只会上传成功一个,后上传的会覆盖以前上传的,单个文件最大10M")]), _vm._v(")")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("报告形式：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("报告类别：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "21px"
    }
  }, [_c('p', [_vm._v("a.委托人对所提供资料和样品来源的真实性和合法性负责；当生产企业与委托人不同，或由代理方填表时，本实验室不承担相关纠纷责任。")]), _vm._v(" "), _c('p', [_vm._v("b.若委托人需将检验检测报告用作仲裁或法律诉讼证据，必须在委托书中事先声明，并承担本实验室因配合司法机关取证而产生的人力、物力及交通等费用。")]), _vm._v(" "), _c('p', [_vm._v("c.此委托书是样品检验检测的依据，是客户获取报告和取回样品的凭证，填表人须确认所填信息真实、完整、准确，应对所填信息负责。如因信息错误导致已出报告的更改，或补充检验检测，须收回原报告，且酌情收取报告更改费或补充检验检测费用。")]), _vm._v(" "), _c('p', [_vm._v("d.本实验室按照委托书及相关标准要求开展检验检测活动，本委托检验检测的数据、结果仅适用于收到的样品，不代表委托人/生产企业其他同批次或同类产品质量。委托人不得利用报告从事虚假宣传和其他违法活动。")]), _vm._v(" "), _c('p', [_vm._v("e.依此委托书进行检验检测期间，如委托人/代理方提出终止检验检测，仍须承担已完成检验检测项目所产生的费用；如委托人提出变更检验检测要求，须重新提交委托书，实验室将以新的委托书作为最终依据并重新核算检验检测费用。")]), _vm._v(" "), _c('p', [_vm._v("f.为保证检验检测和技术服务的质量，委托人应尽可能详细的提供检验检测所需的各种资料和辅助工具（或配件），包括检验检测方案、所需的各种辅助工具（或配件）以及注意事项等。")]), _vm._v(" "), _c('p', [_vm._v("g.委托人如对检验检测样品保护有特别要求的，需在填委托书时特别提出。")]), _vm._v(" "), _c('p', [_vm._v("h.由于未预料的工作量增加不能按要求时间完成或因设备、人员或环境条件等暂时性原因而不具备能力开展委托的项目，我方可选择分包试验。若委托人不同意，请注明。")]), _vm._v(" "), _c('p', [_vm._v("i.本实验室对检验检测过程中获得或产生的客户有关信息和客户非公开性的资料予以保密。")]), _vm._v(" "), _c('p', [_vm._v("j.委托人若对报告有异议，需在收到报告之日起15个工作日内书面提出，否则视为接受；试验费用应在约定的时间内支付，逾期将向委托人收取违约金。")]), _vm._v(" "), _c('p', [_vm._v("k.如委托任务涉及赛宝CE认证申请，请填写委托合同中附表《CE认证申请信息表》的内容。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('span', [_vm._v("委托人/代理方名称："), _c('br'), _vm._v("Client / Agent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("实验室名称："), _c('br'), _vm._v("Laboratory")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "color"
  }, [_vm._v("经办人签章："), _c('br'), _vm._v("Stamp / Signature：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("经办人签章："), _c('br'), _vm._v("Stamp / Signature：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_c('span', [_vm._v("日   期/Date：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "21px"
    }
  }, [_c('p', [_vm._v(" 1 此文本用来统一本整机板块检验检测委托书形式；")]), _vm._v(" "), _c('p', [_vm._v("2生产者对应于制造商；生产企业对应于生产单位；")]), _vm._v(" "), _c('p', [_vm._v("3若有样品其他信息，如样品生产日期等，可在“型号规格/样品描述”栏目中填写；")]), _vm._v(" "), _c('p', [_vm._v("4 为确保委托信息的完整性，填写的信息不能简写，应以实际内容完整填写；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "21px"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "18%",
      "margin-top": "-65px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": __webpack_require__(515)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "6px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  CEPREI-ZB-HT01-202102")])])])
}]}

/***/ }),

/***/ 1200:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#E6F0F2"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "45px",
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px"
    }
  }, [_vm._v("\n\t\t您的回答有助于我们了解此培训项目的效果，持续改进后续培训项目。感谢您填写这份问卷！"), _c('br'), _vm._v("\n\t\t姓名："), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  }), _vm._v("  "), _c('br'), _vm._v("\n\t\t电话："), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入电话"
    },
    model: {
      value: (_vm.data.pone),
      callback: function($$v) {
        _vm.$set(_vm.data, "pone", $$v)
      },
      expression: "data.pone"
    }
  }), _vm._v("  "), _c('br'), _vm._v("\n\t\t邮箱："), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  }), _vm._v("  \n\t\t"), _c('br')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("1.您对此次培训效果是否满意？")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n\t\t"), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.data.radio1),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio1", $$v)
      },
      expression: "data.radio1"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.data.radio1),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio1", $$v)
      },
      expression: "data.radio1"
    }
  }, [_vm._v("比较满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.data.radio1),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio1", $$v)
      },
      expression: "data.radio1"
    }
  }, [_vm._v("一般满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.data.radio1),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio1", $$v)
      },
      expression: "data.radio1"
    }
  }, [_vm._v("不满意")])]], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("2.您对培训课程内容设置是否满意？")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n\t\t"), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.data.radio2),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio2", $$v)
      },
      expression: "data.radio2"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.data.radio2),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio2", $$v)
      },
      expression: "data.radio2"
    }
  }, [_vm._v("比较满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.data.radio2),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio2", $$v)
      },
      expression: "data.radio2"
    }
  }, [_vm._v("一般满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.data.radio2),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio2", $$v)
      },
      expression: "data.radio2"
    }
  }, [_vm._v("不满意")])]], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("3.您对培训课时安排是否满意？")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n\t\t"), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.data.radio3),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio3", $$v)
      },
      expression: "data.radio3"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.data.radio3),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio3", $$v)
      },
      expression: "data.radio3"
    }
  }, [_vm._v("比较满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.data.radio3),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio3", $$v)
      },
      expression: "data.radio3"
    }
  }, [_vm._v("一般满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.data.radio3),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio3", $$v)
      },
      expression: "data.radio3"
    }
  }, [_vm._v("不满意")])]], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("4.您对培训教材或讲义是否满意？")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n\t\t"), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.data.radio4),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio4", $$v)
      },
      expression: "data.radio4"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.data.radio4),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio4", $$v)
      },
      expression: "data.radio4"
    }
  }, [_vm._v("比较满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.data.radio4),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio4", $$v)
      },
      expression: "data.radio4"
    }
  }, [_vm._v("一般满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.data.radio4),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio4", $$v)
      },
      expression: "data.radio4"
    }
  }, [_vm._v("不满意")])]], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("5.您对授课讲师表达能力和授课技巧是否满意？")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n\t\t"), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.data.radio5),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio5", $$v)
      },
      expression: "data.radio5"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.data.radio5),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio5", $$v)
      },
      expression: "data.radio5"
    }
  }, [_vm._v("比较满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.data.radio5),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio5", $$v)
      },
      expression: "data.radio5"
    }
  }, [_vm._v("一般满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.data.radio5),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio5", $$v)
      },
      expression: "data.radio5"
    }
  }, [_vm._v("不满意")])]], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("6.您对授课讲师专业水平是否满意？")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n\t\t"), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.data.radio6),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio6", $$v)
      },
      expression: "data.radio6"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.data.radio6),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio6", $$v)
      },
      expression: "data.radio6"
    }
  }, [_vm._v("比较满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.data.radio6),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio6", $$v)
      },
      expression: "data.radio6"
    }
  }, [_vm._v("一般满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.data.radio6),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio6", $$v)
      },
      expression: "data.radio6"
    }
  }, [_vm._v("不满意")])]], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("7.您对此次培训的会务工作是否满意？")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n\t\t"), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.data.radio7),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio7", $$v)
      },
      expression: "data.radio7"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.data.radio7),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio7", $$v)
      },
      expression: "data.radio7"
    }
  }, [_vm._v("比较满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.data.radio7),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio7", $$v)
      },
      expression: "data.radio7"
    }
  }, [_vm._v("一般满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.data.radio7),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio7", $$v)
      },
      expression: "data.radio7"
    }
  }, [_vm._v("不满意")])]], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("8.您对本次培训的整体评价是否满意？")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n\t\t"), [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.data.radio8),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio8", $$v)
      },
      expression: "data.radio8"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.data.radio8),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio8", $$v)
      },
      expression: "data.radio8"
    }
  }, [_vm._v("比较满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.data.radio8),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio8", $$v)
      },
      expression: "data.radio8"
    }
  }, [_vm._v("一般满意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.data.radio8),
      callback: function($$v) {
        _vm.$set(_vm.data, "radio8", $$v)
      },
      expression: "data.radio8"
    }
  }, [_vm._v("不满意")])]], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("9.您对本次的培训是否还有其他的改进建议？")]), _vm._v(" "), _c('br'), _vm._v("  \n\t\t "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "3800",
      "show-word-limit": "",
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 3
      }
    },
    model: {
      value: (_vm.data.suggest),
      callback: function($$v) {
        _vm.$set(_vm.data, "suggest", $$v)
      },
      expression: "data.suggest"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('span', [_vm._v("10.您还有需要参加哪些方面的培训？")]), _vm._v(" "), _c('br'), _vm._v("  \n\t\t "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "3800",
      "show-word-limit": "",
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 3
      }
    },
    model: {
      value: (_vm.data.need),
      callback: function($$v) {
        _vm.$set(_vm.data, "need", $$v)
      },
      expression: "data.need"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "font-size": "19px",
      "font-weight": "bold"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveDiaoCha();
      }
    }
  }, [_vm._v(" 提交意见 ")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n  "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.ceprei.com/assets/img/logo1-default.png",
      "alt": "Logo"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#DCDCDC",
      "padding-top": "3px",
      "padding-bottom": "1px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#E6F0F2"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "250%",
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("培训满意度评价表")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "15px",
      "color": "#97a8be"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/"
    }
  }, [_vm._v("首页")]), _vm._v(" / 培训满意度评价表 ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  粤ICP备09030372号")]), _vm._v(" "), _c('p', [_vm._v("网站维护：020-87237193 业务联系：020-87236881")])])])
}]}

/***/ }),

/***/ 1201:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUser
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180",
      "sortable": ""
    }
  })], 1)]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1202:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "-5px",
      "width": "1000px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "inline": true,
      "label": "left",
      "label-width": "60px",
      "size": "mini"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("委托单")])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-5px"
    }
  }, [_c('strong', [_vm._v("委托方")])])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin": "-5px"
    }
  }, [_c('strong', [_vm._v("编号")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientName),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientName", $$v)
      },
      expression: "form.clientName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientContacts),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientContacts", $$v)
      },
      expression: "form.clientContacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientPhone),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientPhone", $$v)
      },
      expression: "form.clientPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址 "
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientAddr),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientAddr", $$v)
      },
      expression: "form.clientAddr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.clientMail),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientMail", $$v)
      },
      expression: "form.clientMail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "传真"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.form.clientFax),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientFax", $$v)
      },
      expression: "form.clientFax"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-3px"
    }
  }, [_c('strong', [_vm._v("样品信息")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-1px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "data": _vm.tableData1,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "100",
      "type": "index"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "样品名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "specs",
      "label": "型号规格"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trademark",
      "label": "商标"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-3px"
    }
  }, [_c('strong', [_vm._v("检验要求")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检验依据",
      "label-width": "78px",
      "prop": "basis"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "270px"
    },
    model: {
      value: (_vm.form.basis),
      callback: function($$v) {
        _vm.$set(_vm.form, "basis", $$v)
      },
      expression: "form.basis"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "检验项目",
      "label-width": "78px",
      "prop": "items"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "270px"
    },
    model: {
      value: (_vm.form.items),
      callback: function($$v) {
        _vm.$set(_vm.form, "items", $$v)
      },
      expression: "form.items"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "该检验是否与诉讼有关",
      "label-width": "160px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.lawsuit),
      callback: function($$v) {
        _vm.$set(_vm.form, "lawsuit", $$v)
      },
      expression: "form.lawsuit"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form.lawsuit),
      callback: function($$v) {
        _vm.$set(_vm.form, "lawsuit", $$v)
      },
      expression: "form.lawsuit"
    }
  }, [_vm._v("是")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-3px"
    }
  }, [_c('strong', [_vm._v("报告要求")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报告版本",
      "label-width": "70px"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": function (val) { return _vm.checkinlist(val); }
    },
    model: {
      value: (_vm.form.reportType),
      callback: function($$v) {
        _vm.$set(_vm.form, "reportType", $$v)
      },
      expression: "form.reportType"
    }
  }, _vm._l((_vm.reportTypes), function(report) {
    return _c('el-checkbox', {
      key: report,
      attrs: {
        "label": report
      }
    }, [_vm._v(_vm._s(report))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报告形式",
      "label-width": "70px"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": function (val) { return _vm.checkinlist1(val); }
    },
    model: {
      value: (_vm.form.reportForm),
      callback: function($$v) {
        _vm.$set(_vm.form, "reportForm", $$v)
      },
      expression: "form.reportForm"
    }
  }, _vm._l((_vm.forms), function(form1) {
    return _c('el-checkbox', {
      key: form1.value,
      attrs: {
        "label": form1.value
      }
    }, [_vm._v(_vm._s(form1.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "如对报告有其他要求，请说明",
      "label-width": "195px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "770px"
    },
    model: {
      value: (_vm.form.reportRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "reportRemark", $$v)
      },
      expression: "form.reportRemark"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left",
      "margin": "-5px"
    }
  }, [_c('strong', [_vm._v("样品处理")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.form, "sampleHandle", $$v)
      },
      expression: "form.sampleHandle"
    }
  }, [_vm._v("邮寄")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.form.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.form, "sampleHandle", $$v)
      },
      expression: "form.sampleHandle"
    }
  }, [_vm._v("销毁")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    },
    model: {
      value: (_vm.form.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.form, "sampleHandle", $$v)
      },
      expression: "form.sampleHandle"
    }
  }, [_vm._v("自取")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4"
    },
    model: {
      value: (_vm.form.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.form, "sampleHandle", $$v)
      },
      expression: "form.sampleHandle"
    }
  }, [_vm._v("保管")])], 1)], 1), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "被委托部门"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    model: {
      value: (_vm.form.clientDept),
      callback: function($$v) {
        _vm.$set(_vm.form, "clientDept", $$v)
      },
      expression: "form.clientDept"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "下委托单人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    model: {
      value: (_vm.form.userId),
      callback: function($$v) {
        _vm.$set(_vm.form, "userId", $$v)
      },
      expression: "form.userId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "下委托公司"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    model: {
      value: (_vm.form.enterpriseId),
      callback: function($$v) {
        _vm.$set(_vm.form, "enterpriseId", $$v)
      },
      expression: "form.enterpriseId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('el-form-item', {
    attrs: {
      "label": "外网委托标识"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "170px"
    },
    model: {
      value: (_vm.form.isextranet),
      callback: function($$v) {
        _vm.$set(_vm.form, "isextranet", $$v)
      },
      expression: "form.isextranet"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("确认下单")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "subData",
    attrs: {
      "model": _vm.obj,
      "label-width": "90px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "样品名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入样品名称"
    },
    model: {
      value: (_vm.obj.name),
      callback: function($$v) {
        _vm.$set(_vm.obj, "name", $$v)
      },
      expression: "obj.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格型号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入规格型号"
    },
    model: {
      value: (_vm.obj.specs),
      callback: function($$v) {
        _vm.$set(_vm.obj, "specs", $$v)
      },
      expression: "obj.specs"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商标"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入商标"
    },
    model: {
      value: (_vm.obj.trademark),
      callback: function($$v) {
        _vm.$set(_vm.obj, "trademark", $$v)
      },
      expression: "obj.trademark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入数量"
    },
    model: {
      value: (_vm.obj.number),
      callback: function($$v) {
        _vm.$set(_vm.obj, "number", $$v)
      },
      expression: "obj.number"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1203:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "visitor",
      "label": "姓名",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visitorIdcard",
      "label": "身份证",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visitorDep",
      "label": "来访单位",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预约到达日期",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("moment")(scope.row.visitTime, 'YYYY-MM-DD HH:mm:ss')))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "visitContent",
      "label": "来访原因",
      "width": "220"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "预约信息状态",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.appoint(scope.row.state)))]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pull-right clearfix",
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.totalsize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1204:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age",
      "label": "年龄",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth",
      "label": "生日",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "地址",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sex", $$v)
      },
      expression: "editForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.editForm.age),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "age", $$v)
      },
      expression: "editForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.editForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "birth", $$v)
      },
      expression: "editForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "addr", $$v)
      },
      expression: "editForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "sex", $$v)
      },
      expression: "addForm.sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "年龄"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.addForm.age),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "age", $$v)
      },
      expression: "addForm.age"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生日"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.addForm.birth),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "birth", $$v)
      },
      expression: "addForm.birth"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.addForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "addr", $$v)
      },
      expression: "addForm.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    ref: "canvas",
    on: {
      "mousedown": _vm.mouseDown,
      "mousemove": _vm.mouseMove,
      "mouseup": _vm.mouseUp,
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1206:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "菜单名"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "主键编号",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resName",
      "label": "资源名称",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resPath",
      "label": "资源路径",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "parentId",
      "label": "上级资源",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resIcon",
      "label": "资源图标",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resDesc",
      "label": "资源描述",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resSort",
      "label": "菜单排序",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resOpen",
      "label": "是否展开",
      "formatter": _vm.formatterColumn,
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "label": "状态",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "aria-placeholder": "请输入",
      "label": "主键编号"
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": _vm.readonly
    },
    model: {
      value: (_vm.form.id),
      callback: function($$v) {
        _vm.$set(_vm.form, "id", $$v)
      },
      expression: "form.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资源名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.resName),
      callback: function($$v) {
        _vm.$set(_vm.form, "resName", $$v)
      },
      expression: "form.resName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "资源路径"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.resPath),
      callback: function($$v) {
        _vm.$set(_vm.form, "resPath", $$v)
      },
      expression: "form.resPath"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上级资源"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.parentId),
      callback: function($$v) {
        _vm.$set(_vm.form, "parentId", $$v)
      },
      expression: "form.parentId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "菜单排序"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.resSort),
      callback: function($$v) {
        _vm.$set(_vm.form, "resSort", $$v)
      },
      expression: "form.resSort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否展开"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.resOpen),
      callback: function($$v) {
        _vm.$set(_vm.form, "resOpen", $$v)
      },
      expression: "form.resOpen"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.state),
      callback: function($$v) {
        _vm.$set(_vm.form, "state", $$v)
      },
      expression: "form.state"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.open2()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }]
  }, [_c('div', {
    attrs: {
      "id": "neirong"
    }
  }, [_c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "150px",
      "font-size": "23px",
      "color": "red"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "10px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', {
    staticStyle: {
      "border": "0px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("报价单号："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("客户名称 :"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("报价方："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("联系人："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("报价人："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("电话："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("电话："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("邮箱E-mail："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "0px"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("邮箱："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px",
      "line-height": "50px"
    }
  }, [_vm._v("  \r\n            尊敬的  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.providePartsMaterial),
      expression: "data.providePartsMaterial"
    }],
    staticStyle: {
      "border": "solid",
      "border-left": "0px",
      "border-top": "0px",
      "border-right": "0px",
      "margin-left": "0px",
      "height": "30px",
      "outline": "medium",
      "font-size": "21px",
      "text-align": "center"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "maxlength": "3800",
      "size": "15"
    },
    domProps: {
      "value": (_vm.data.providePartsMaterial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "providePartsMaterial", $event.target.value)
      }
    }
  }), _vm._v("  先生/女士：  "), _c('br'), _vm._v("\r\n                 您好！感谢您对我实验室业务的垂询，以下是我们根据您的询价信息提供的报价。\r\n       ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "line-height": "28px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.list1), function(item, i) {
    return _c('tr', {
      key: i
    }, [_c('th', [_vm._v(_vm._s(i + 1) + " ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("啊请稍等 ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("型号规格（样品描述）")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("数量 ")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("检测项目 ,x.fgnb,mxcnv,,ssssssssssss111111111111111111111111111111111111111111111111")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v("检测项目 ,x.fgnb,mxcnv,,ssssssssssss11111111111111111111111111111111111111111111111111")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "word-wrap": "break-word",
        "word-break": "break-all"
      }
    }, [_vm._v(" 11 ")])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }), _vm._v(" "), _c('th', [_vm._v("合计 ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr'), _vm._v(" "), _vm._m(4)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "height": "50px",
      "border-bottom": "2px solid black",
      "width": "150px"
    },
    on: {
      "click": function($event) {
        _vm.imgDialog = true;
      }
    }
  }, [(_vm.data.signaturelink) ? _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "45px"
    },
    attrs: {
      "src": _vm.data.signaturelink
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _c('br'), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \r\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "divcenter"
  }, [_c('el-dialog', {
    attrs: {
      "title": "授权人签名",
      "visible": _vm.imgDialog,
      "width": "900px",
      "lock-scroll": false
    },
    on: {
      "update:visible": function($event) {
        _vm.imgDialog = $event
      }
    }
  }, [_c('esign', {
    attrs: {
      "token": _vm.data.timeStamp + _vm.data.conId,
      "imgDialog": _vm.imgDialog
    },
    on: {
      "callback": _vm.receiveSignature
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "ont-size": "14px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1000px",
      "min-width": "1000px",
      "margin": "0 auto",
      "font-size": "20px",
      "margin-top": "10px",
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("报 价 单")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("工业和信息化部电子第五研究所  （中  国  赛  宝  实  验  室）  装备与整机研究部")]), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-40px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sava('暂存');
      }
    }
  }, [_vm._v(" 暂存 ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "-150px",
      "margin-top": "-40px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit('提交');
      }
    }
  }, [_vm._v(" 提交 ")])], 1), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _vm._m(10)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("序号 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("样品名称 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("型号规格（样品描述）")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5%"
    }
  }, [_vm._v("数量 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v("检测项目 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("检测依据/测试条件 ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("费用（RMB） ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "rowspan": "4"
    }
  }, [_c('p', [_vm._v("收款账户：")]), _vm._v(" "), _c('p', [_vm._v("  单位名称：工业和信息化部电子第五研究所")]), _vm._v(" "), _c('p', [_vm._v("  开户银行：中信银行广州分行")]), _vm._v(" "), _c('p', [_vm._v("  银行帐号：7443020183100002212")]), _vm._v(" "), _c('p', [_vm._v("  汇款时请备注“装备与整机研究部”和“报价单号”")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\r\n                  付款方式：\r\n                 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "rowspan": "4"
    }
  }, [_c('p', [_vm._v("备注：")]), _vm._v(" "), _c('p', [_vm._v("  1、此报价依据贵单位提供的询价信息给出，如实际委托时的要求与此报价单询价信息不符，将导致报价变化；")]), _vm._v(" "), _c('p', [_vm._v("  2、此报价不含重测费，如重测，按具体项目收费；")]), _vm._v(" "), _c('p', [_vm._v("  3、如项目进行过程中，委托方要求终止测试，则已测试的项目要收费；")]), _vm._v(" "), _c('p', [_vm._v("  4、此报价单有效期15天，超过15天未签字确认，则此报价失效；")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("  如同意以上报价，请签字盖章后回传。此报价单将做为服务和收费依据。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "height": "50px"
    }
  }, [_c('br'), _vm._v("客户签字:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "height": "50px",
      "border-bottom": "2px solid black",
      "width": "130px"
    }
  }, [_c('br'), _vm._v("11"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "height": "50px"
    }
  }, [_c('br'), _vm._v("报价人:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "height": "50px"
    }
  }, [_c('br'), _vm._v("工业和信息化部电子第五研究所装备与整机研究部")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "9%",
      "margin-top": "-62px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": __webpack_require__(515)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "6px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  CEPREI-ZB-HT01-202102")])])])
}]}

/***/ }),

/***/ 1208:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "15px",
      "width": "80%",
      "min-width": "800px"
    },
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "inline": true,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("个人信息")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-col', [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "idcard"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.idcard),
      callback: function($$v) {
        _vm.$set(_vm.form, "idcard", $$v)
      },
      expression: "form.idcard"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "addr"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "510px"
    },
    model: {
      value: (_vm.form.addr),
      callback: function($$v) {
        _vm.$set(_vm.form, "addr", $$v)
      },
      expression: "form.addr"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("立即修改")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1209:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#e6f0f2"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "margin-top": "30px",
      "min-width": "730px",
      "background-color": "#e6f0f2"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入企业名称",
      "size": "large"
    },
    model: {
      value: (_vm.unitName),
      callback: function($$v) {
        _vm.unitName = $$v
      },
      expression: "unitName"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("企业名称:")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "color": "#08c",
      "font-weight": "bold"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.loadData()
      }
    },
    slot: "append"
  }, [_vm._v("查询/Search")])], 2)], 1), _vm._v(" "), (!_vm.seachShow) ? _c('div', {
    staticStyle: {
      "width": "85%",
      "margin": "0 auto",
      "border": "1px dashed #000",
      "margin-top": "40px",
      "min-width": "730px",
      "background-color": "#e6f0f2"
    }
  }, [_c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "background-color": "#e6f0f2"
    },
    attrs: {
      "data": _vm.tableData,
      "cell-style": _vm.cellStyle,
      "header-cell-style": _vm.headerStyle,
      "height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "unitName",
      "label": "单位名称",
      "width": "280"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "establishmentTime",
      "label": "成立时间",
      "width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "注册地址",
      "width": "450"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "capital",
      "label": "注册资本（万元）",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shareholder",
      "label": "股东名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ratio",
      "label": "持股比例",
      "width": "100"
    }
  })], 1), _vm._v(" "), _vm._m(2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.seachShow),
      expression: "seachShow"
    }],
    staticStyle: {
      "widht": "20px",
      "height": "1800px",
      "background-color": "#e6f0f2"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n  "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" \n  "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.ceprei.com/assets/img/logo1-default.png",
      "alt": "Logo"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#dcdcdc",
      "padding-top": "3px",
      "padding-bottom": "1px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "background-color": "#e6f0f2"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "250%",
      "font-weight": "bold",
      "margin-top": "10px"
    }
  }, [_vm._v("\n         所办企业信息查询\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "15px",
      "color": "#97a8be"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/"
    }
  }, [_vm._v("首页")]), _vm._v(" / 所办企业信息查询\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('p', {
    staticStyle: {}
  }, [_vm._v("如有疑问或发现假冒五所（赛宝）名称、商标的情况，请咨询 38390984，gaojing@ceprei.com ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "background-color": "#e6f0f2"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://guangzhou.cyberpolice.cn/netalarm/netalarm/Welcome.jsp?bano=4401060100873",
      "data-v-4d3159fe": "",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/cyberpolice.bfb5ba4.gif",
      "border": "0",
      "data-v-4d3159fe": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  粤ICP备09030372号\n      ")]), _vm._v(" "), _c('p', [_vm._v("网站维护：020-87237193 业务联系：020-87236881")])])])
}]}

/***/ }),

/***/ 1210:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入[委托名称]"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.page.criteria),
      callback: function($$v) {
        _vm.$set(_vm.page, "criteria", $$v)
      },
      expression: "page.criteria"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.query
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "clientName",
      "label": "委托方名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "simpleName",
      "label": "样品名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "basis",
      "label": "检验依据",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "items",
      "label": "检验项目",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "该检验是否与诉讼有关",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.Whether(scope.row.lawsuit)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "380"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.downPort(scope.$index, scope.row)
            }
          }
        }, [_c('a', {
          attrs: {
            "href": _vm.href
          }
        }, [_vm._v("下载报告")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pull-right clearfix",
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.totalsize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisibleComplaint
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisibleComplaint = $event
      }
    }
  }, [_c('el-form', {
    ref: "conData",
    attrs: {
      "model": _vm.conData,
      "rules": _vm.rules2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "label": "委托编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.conData.consignationId),
      callback: function($$v) {
        _vm.$set(_vm.conData, "consignationId", $$v)
      },
      expression: "conData.consignationId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "120px!important"
    },
    attrs: {
      "label": "满意程度选项"
    }
  }), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "width": "100px!important"
    },
    model: {
      value: (_vm.conData.checkList),
      callback: function($$v) {
        _vm.$set(_vm.conData, "checkList", $$v)
      },
      expression: "conData.checkList"
    }
  }, _vm._l((_vm.checkLists), function(report) {
    return _c('el-radio', {
      key: report,
      attrs: {
        "label": report
      }
    }, [_vm._v(_vm._s(report))])
  }), 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "投诉或意见",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.conData.remark),
      callback: function($$v) {
        _vm.$set(_vm.conData, "remark", $$v)
      },
      expression: "conData.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisibleComplaint = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addComplaintalert('conData')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisibleSatisfaction
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisibleSatisfaction = $event
      }
    }
  }, [_c('el-form', {
    ref: "conData2",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.conData2,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "label": "委托编号"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.conData2.consignationId),
      callback: function($$v) {
        _vm.$set(_vm.conData2, "consignationId", $$v)
      },
      expression: "conData2.consignationId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "满意度内容",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticStyle: {},
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.conData2.remark),
      callback: function($$v) {
        _vm.$set(_vm.conData2, "remark", $$v)
      },
      expression: "conData2.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisibleComplaint = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addSatisfactionalert('conData2')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1211:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入[姓名|手机号]"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.page.criteria),
      callback: function($$v) {
        _vm.$set(_vm.page, "criteria", $$v)
      },
      expression: "page.criteria"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.query
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cnee",
      "label": "收货人",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "area",
      "label": "所在地区",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "详细地址",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editAddr(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteAddr(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pull-right clearfix",
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.totalsize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "subData",
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "rules": _vm.rules,
      "model": _vm.subData,
      "label-width": "100px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人",
      "prop": "cnee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入收货人"
    },
    model: {
      value: (_vm.subData.cnee),
      callback: function($$v) {
        _vm.$set(_vm.subData, "cnee", $$v)
      },
      expression: "subData.cnee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.subData.phone),
      callback: function($$v) {
        _vm.$set(_vm.subData, "phone", $$v)
      },
      expression: "subData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在地区",
      "prop": "area"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入所在地区"
    },
    model: {
      value: (_vm.subData.area),
      callback: function($$v) {
        _vm.$set(_vm.subData, "area", $$v)
      },
      expression: "subData.area"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.subData.addr),
      callback: function($$v) {
        _vm.$set(_vm.subData, "addr", $$v)
      },
      expression: "subData.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAddr('subData')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1212:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page6...\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(251);
module.exports = __webpack_require__(537);


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timeFormat = timeFormat;
exports.dateFormat = dateFormat;
exports.state = state;
exports.type = type;
exports.recordType = recordType;
exports.showType = showType;
exports.cardState = cardState;
exports.Whether = Whether;
exports.sampleHandle = sampleHandle;
exports.appoint = appoint;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function timeFormat(row, column) {
    var date = row[column.property];
    if (date == undefined) {
        return "";
    }
    return (0, _moment2.default)(date).format("YYYY-MM-DD HH:mm:ss");
};

function dateFormat(row, column) {
    var date = row[column.property];
    if (date == undefined) {
        return "";
    }
    return (0, _moment2.default)(date).format("YYYY-MM-DD");
};

function state(row) {
    var date = row;
    return date == '10' ? '正常' : date == '20' ? '禁用' : '';
};

function type(row) {
    var date = row;
    return date == '10' ? '个人' : date == '20' ? '公司' : '';
};

function recordType(row) {
    var data = row;
    var str = "";

    if (data == '10') {
        str = "密码";
    } else if (data == '20') {
        str = "用户卡";
    } else if (data == '30') {
        str = "管理员卡";
    } else if (data == '40') {
        str = "人脸";
    } else if (data == '50') {
        str = "身份证";
    } else if (data == '60') {
        str = "手机远程";
    } else if (data == '70') {
        str = "二维码";
    } else if (data == '80') {
        str = "指纹开锁";
    }
    return str;
};

function showType(row) {
    var data = row;
    var str = "";

    if (data == '10') {
        str = "图片全屏";
    } else if (data == '20') {
        str = "视频全屏";
    } else if (data == '30') {
        str = "图片视频1:2";
    } else if (data == '40') {
        str = "视频图片2:1";
    } else if (data == '50') {
        str = "图片1:2";
    } else if (data == '60') {
        str = "图片2:1";
    } else if (data == '70') {
        str = "图片1:1";
    }
    return str;
};

function cardState(row) {
    var date = row;
    return date == '10' ? '已发卡' : date == '20' ? '未发卡' : '';
};

function Whether(row) {
    var date = row;
    return date == '1' ? '是' : date == '2' ? '否' : '';
}
function sampleHandle(row) {
    var data = row;
    var str = "";
    if (data == '1') {
        str = "邮寄";
    } else if (data == '2') {
        str = "销毁";
    } else if (data == '3') {
        str = "自取";
    } else if (data == "4") {
        str = "保管";
    }
    return str;
}
function appoint(row) {
    var data = row;
    var str = "";
    if (data == '10') {
        str = "申请中";
    } else if (data == '20') {
        str = "预约成功";
    } else if (data == '30') {
        str = "到访确认";
    } else if (data == "40") {
        str = "离场确认";
    }
    return str;
}

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dateFormat = exports.formatDate = exports.RequestGet = exports.getImageName = exports.updateFIle = exports.RequestPost = exports.PageSize = exports.fileUrls = exports.url = undefined;

var _axios = __webpack_require__(253);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(371);

var _routes = __webpack_require__(260);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var base = '';
var url = exports.url = "https://fw.ceprei.com/service";
var fileUrls = exports.fileUrls = 'https://fw.ceprei.com/service';
var PageSize = exports.PageSize = 10;

var RequestPost = exports.RequestPost = function RequestPost(url1, params) {
    return _axios2.default.post(url + url1, params, {
        headers: {
            'token': sessionStorage.getItem("token")
        } }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        var message = "";
        switch (error.response.status) {
            case 400:
                message = '错误请求';
                break;
            case 401:
                message = '未授权，请重新登录';
                break;
            case 403:
                message = '拒绝访问';
                break;
            case 404:
                message = '请求错误,未找到该资源';
                break;
            case 405:
                message = '请求方法未允许';
                break;
            case 408:
                message = '请求超时';
                break;
            case 500:
                message = '服务器端出错';
                break;
            case 501:
                message = '网络未实现';
                break;
            case 502:
                message = '网络错误';
                break;
            case 503:
                message = '服务不可用';
                break;
            case 504:
                message = '网络超时';
                break;
            case 505:
                message = 'http版本不支持该请求';
                break;
            case 608:
                message = 'token生效，请重新登录';
                break;
            default:
                message = '\u8FDE\u63A5\u9519\u8BEF' + err.response.status;
        }
        (0, _elementUi.Message)({
            message: message,
            type: 'error'
        });
    });
};
var updateFIle = exports.updateFIle = function updateFIle(url, params) {
    return _axios2.default.post(url, params, {
        headers: {
            'token': sessionStorage.getItem("token"),
            'Content-Type': 'multipart/form-data'
        } }).then(function (res) {
        return res.data;
    }).catch(function (error) {
        var message = "";
        switch (error.response.status) {
            case 400:
                message = '错误请求';
                break;
            case 401:
                message = '未授权，请重新登录';
                break;
            case 403:
                message = '拒绝访问';
                break;
            case 404:
                message = '请求错误,未找到该资源';
                break;
            case 405:
                message = '请求方法未允许';
                break;
            case 408:
                message = '请求超时';
                break;
            case 500:
                message = '服务器端出错';
                break;
            case 501:
                message = '网络未实现';
                break;
            case 502:
                message = '网络错误';
                break;
            case 503:
                message = '服务不可用';
                break;
            case 504:
                message = '网络超时';
                break;
            case 505:
                message = 'http版本不支持该请求';
                break;
            case 608:
                message = 'token生效，请重新登录';
                break;
            default:
                message = '\u8FDE\u63A5\u9519\u8BEF' + err.response.status;
        }
        (0, _elementUi.Message)({
            message: message,
            type: 'error'
        });
    });
};
var getImageName = exports.getImageName = function getImageName(url, params) {
    return _axios2.default.get(url, { headers: {
            'token': sessionStorage.getItem("token")
        }, params: params }).then(function (res) {
        return res.data;
    }).catch(function (error) {

        var message = "";
        switch (error.response.status) {
            case 400:
                message = '错误请求';
                break;
            case 401:
                message = '未授权，请重新登录';
                break;
            case 403:
                message = '拒绝访问';
                break;
            case 404:
                message = '请求错误,未找到该资源';
                break;
            case 405:
                message = '请求方法未允许';
                break;
            case 408:
                message = '请求超时';
                break;
            case 500:
                message = '服务器端出错';
                break;
            case 501:
                message = '网络未实现';
                break;
            case 502:
                message = '网络错误';
                break;
            case 503:
                message = '服务不可用';
                break;
            case 504:
                message = '网络超时';
                break;
            case 505:
                message = 'http版本不支持该请求';
                break;
            case 608:
                message = 'token生效，请重新登录';
                break;
            default:
                message = '\u8FDE\u63A5\u9519\u8BEF' + err.response.status;
        }
        (0, _elementUi.Message)({
            message: message,
            type: 'error'
        });
    });
};

var RequestGet = exports.RequestGet = function RequestGet(url1, params) {
    return _axios2.default.get(url + url1, { headers: {
            'token': sessionStorage.getItem("token")
        }, params: params }).then(function (res) {
        return res.data;
    }).catch(function (error) {

        var message = "";
        switch (error.response.status) {
            case 400:
                message = '错误请求';
                break;
            case 401:
                message = '未授权，请重新登录';
                break;
            case 403:
                message = '拒绝访问';
                break;
            case 404:
                message = '请求错误,未找到该资源';
                break;
            case 405:
                message = '请求方法未允许';
                break;
            case 408:
                message = '请求超时';
                break;
            case 500:
                message = '服务器端出错';
                break;
            case 501:
                message = '网络未实现';
                break;
            case 502:
                message = '网络错误';
                break;
            case 503:
                message = '服务不可用';
                break;
            case 504:
                message = '网络超时';
                break;
            case 505:
                message = 'http版本不支持该请求';
                break;
            case 608:
                message = 'token生效，请重新登录';
                break;
            default:
                message = '\u8FDE\u63A5\u9519\u8BEF' + err.response.status;
        }
        (0, _elementUi.Message)({
            message: message,
            type: 'error'
        });
    });;
};

var formatDate = exports.formatDate = function formatDate(value, sformat) {
    return undefined.dateFormat(new Date(value), sformat);
};

var dateFormat = exports.dateFormat = function dateFormat(date, sFormat) {

    var time = {
        Year: 0,
        TYear: '0',
        Month: 0,
        TMonth: '0',
        Day: 0,
        TDay: '0',
        Hour: 0,
        THour: '0',
        hour: 0,
        Thour: '0',
        Minute: 0,
        TMinute: '0',
        Second: 0,
        TSecond: '0',
        Millisecond: 0
    };
    time.Year = date.getFullYear();
    time.TYear = String(time.Year).substr(2);
    time.Month = date.getMonth() + 1;
    time.TMonth = time.Month < 10 ? "0" + time.Month : String(time.Month);
    time.Day = date.getDate();
    time.TDay = time.Day < 10 ? "0" + time.Day : String(time.Day);
    time.Hour = date.getHours();
    time.THour = time.Hour < 10 ? "0" + time.Hour : String(time.Hour);
    time.hour = time.Hour < 13 ? time.Hour : time.Hour - 12;
    time.Thour = time.hour < 10 ? "0" + time.hour : String(time.hour);
    time.Minute = date.getMinutes();
    time.TMinute = time.Minute < 10 ? "0" + time.Minute : String(time.Minute);
    time.Second = date.getSeconds();
    time.TSecond = time.Second < 10 ? "0" + time.Second : String(time.Second);
    time.Millisecond = date.getMilliseconds();

    return sFormat.replace(/yyyy/ig, String(time.Year)).replace(/yyy/ig, String(time.Year)).replace(/yy/ig, time.TYear).replace(/y/ig, time.TYear).replace(/MM/g, time.TMonth).replace(/M/g, String(time.Month)).replace(/dd/ig, time.TDay).replace(/d/ig, String(time.Day)).replace(/HH/g, time.THour).replace(/H/g, String(time.Hour)).replace(/hh/g, time.Thour).replace(/h/g, String(time.hour)).replace(/mm/g, time.TMinute).replace(/m/g, String(time.Minute)).replace(/ss/ig, time.TSecond).replace(/s/ig, String(time.Second)).replace(/fff/ig, String(time.Millisecond));
};

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(1162);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(1160);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(1161);

var _Home2 = _interopRequireDefault(_Home);

var _Main = __webpack_require__(1163);

var _Main2 = _interopRequireDefault(_Main);

var _Table = __webpack_require__(517);

var _Table2 = _interopRequireDefault(_Table);

var _Form = __webpack_require__(1175);

var _Form2 = _interopRequireDefault(_Form);

var _user = __webpack_require__(1177);

var _user2 = _interopRequireDefault(_user);

var _Page = __webpack_require__(1178);

var _Page2 = _interopRequireDefault(_Page);

var _Page3 = __webpack_require__(1179);

var _Page4 = _interopRequireDefault(_Page3);

var _Page5 = __webpack_require__(1180);

var _Page6 = _interopRequireDefault(_Page5);

var _echarts = __webpack_require__(1166);

var _echarts2 = _interopRequireDefault(_echarts);

var _TableTest = __webpack_require__(1176);

var _TableTest2 = _interopRequireDefault(_TableTest);

var _resource = __webpack_require__(1181);

var _resource2 = _interopRequireDefault(_resource);

var _register = __webpack_require__(1165);

var _register2 = _interopRequireDefault(_register);

var _record = __webpack_require__(1164);

var _record2 = _interopRequireDefault(_record);

var _modify = __webpack_require__(1184);

var _modify2 = _interopRequireDefault(_modify);

var _affiliate_company = __webpack_require__(1182);

var _affiliate_company2 = _interopRequireDefault(_affiliate_company);

var _placeOrder = __webpack_require__(1171);

var _placeOrder2 = _interopRequireDefault(_placeOrder);

var _placeOrderTable = __webpack_require__(1172);

var _placeOrderTable2 = _interopRequireDefault(_placeOrderTable);

var _chooseDept = __webpack_require__(1168);

var _chooseDept2 = _interopRequireDefault(_chooseDept);

var _customerAddrList = __webpack_require__(1183);

var _customerAddrList2 = _interopRequireDefault(_customerAddrList);

var _certificateAuthenticity = __webpack_require__(1167);

var _certificateAuthenticity2 = _interopRequireDefault(_certificateAuthenticity);

var _emailConSign = __webpack_require__(1169);

var _emailConSign2 = _interopRequireDefault(_emailConSign);

var _quoteSignature = __webpack_require__(1174);

var _quoteSignature2 = _interopRequireDefault(_quoteSignature);

var _questionnaire = __webpack_require__(1173);

var _questionnaire2 = _interopRequireDefault(_questionnaire);

var _enterprise = __webpack_require__(1170);

var _enterprise2 = _interopRequireDefault(_enterprise);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

var routes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}, {
    path: '/updatePwd1',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(538)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    name: '修改密码'

}, {
    path: '/',
    component: _Home2.default,
    name: '我的桌面',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/homeIndex', component: function component(resolve) {
            return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1258)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '主页' }, { path: '/residentList', component: function component(resolve) {
            return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1259)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '用户管理列表' }, { path: '/tableTest', component: _TableTest2.default, name: '列表测试' }, { path: '/user', component: _user2.default, name: '列表' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '系统管理',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/message', component: function component(resolve) {
            return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1260)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '消息管理' }, { path: '/notice', component: function component(resolve) {
            return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1261)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '公告管理' }, { path: '/parameter', component: function component(resolve) {
            return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1262)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '参数设置' }, { path: '/role', component: function component(resolve) {
            return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1263)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '权限管理' }, { path: '/updatePw', component: function component(resolve) {
            return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(538)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '修改密码' }, { path: '/userInfo', component: function component(resolve) {
            return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '账户管理' }, { path: '/userMessage', component: function component(resolve) {
            return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1265)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '基本信息' }, { path: '/resource', component: _resource2.default, name: '系统菜单' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '来访预约',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/appointment', component: _register2.default, name: '预约登记' }, { path: '/record', component: _record2.default, name: '预约记录' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '委托管理',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/commission_order', component: _placeOrder2.default, name: '' }, { path: '/consignationQuery', component: _placeOrderTable2.default, name: '委托查询' }, { path: '/certificate', component: _certificateAuthenticity2.default, name: '证书报告防伪验证中心', meta: { role: false, keepAlive: false } }, { path: '/emailConSign', component: _emailConSign2.default, name: '客户委托填写', meta: { role: false, keepAlive: false } }, { path: '/quoteSignature', component: _quoteSignature2.default, name: '客户委托填写', meta: { role: false, keepAlive: false } }, { path: '/questionnaire', component: _questionnaire2.default, name: '问卷调查', meta: { role: false, keepAlive: false } }, { path: '/enterprise', component: _enterprise2.default, name: '企业信息', meta: { role: false, keepAlive: false } }]
}, {
    path: '/',
    component: _Home2.default,
    name: '个人信息',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/modify', component: _modify2.default, name: '个人信息修改' }, { path: '/affiliate_company', component: _affiliate_company2.default, name: '绑定所属公司' }, { path: '/cumstomer_addrList', component: _customerAddrList2.default, name: '收件地址管理' }]
}, {
    path: '/',
    component: _Home2.default,
    name: 'Charts',
    iconCls: 'fa fa-bar-chart',
    children: [{ path: '/echarts', component: _echarts2.default, name: 'echarts' }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/favicon.300b9dd.png";

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1129)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1191),
  /* scopeId */
  "data-v-13dbb200",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1137)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1204),
  /* scopeId */
  "data-v-47a447b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelPolyfill = __webpack_require__(251);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(31);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(1159);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(371);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(1124);

var _vueRouter = __webpack_require__(1215);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(581);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(244);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(260);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(1125);

var _axios = __webpack_require__(253);

var _axios2 = _interopRequireDefault(_axios);

var _api = __webpack_require__(19);

var _api2 = _interopRequireDefault(_api);

var _format = __webpack_require__(172);

var _format2 = _interopRequireDefault(_format);

var _vueEsign = __webpack_require__(1157);

var _vueEsign2 = _interopRequireDefault(_vueEsign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

_vue2.default.prototype.$message = _elementUi.Message;
_vue2.default.prototype.$axios = _axios2.default;

_vue2.default.use(_vueEsign2.default);
_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.use(__webpack_require__(1214));

var router = new _vueRouter2.default({
  routes: _routes2.default,
  api: _api2.default
});
router.beforeEach(function (to, from, next) {

  if (to.path == '/login') {
    sessionStorage.removeItem('user');
  }
  var user = JSON.parse(sessionStorage.getItem('user'));
  if (to.path == '/certificate') {
    next();
  }
  if (to.path == '/emailConSign' || to.path == '/quoteSignature' || to.path == '/questionnaire' || to.path == '/enterprise') {
    next();
  } else if (!user && to.path != '/certificate') {
    next({ path: '/certificate' });
  } else {
    next();
  }
});

new _vue2.default({
  router: router,
  store: _store2.default,

  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

_vue2.default.directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var increment = exports.increment = function increment(_ref) {
    var commit = _ref.commit;

    commit('INCREMENT');
};
var decrement = exports.decrement = function decrement(_ref2) {
    var commit = _ref2.commit;

    commit('DECREMENT');
};

/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCount = exports.getCount = function getCount(state) {
    return state.count;
};

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(31);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(244);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(579);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(580);

var getters = _interopRequireWildcard(_getters);

function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};if (obj != null) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
        }newObj.default = obj;return newObj;
    }
}

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

_vue2.default.use(_vuex2.default);

var state = {
    count: 10
};

var mutations = {
    INCREMENT: function INCREMENT(state) {
        state.count++;
    },
    DECREMENT: function DECREMENT(state) {
        state.count--;
    }
};

exports.default = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    state: state,
    mutations: mutations
});

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    width: {
      type: Number,
      default: 800
    },
    height: {
      type: Number,
      default: 300
    },
    lineWidth: {
      type: Number,
      default: 4
    },
    lineColor: {
      type: String,
      default: '#000000'
    },
    bgColor: {
      type: String,
      default: ''
    },
    isCrop: {
      type: Boolean,
      default: false
    },
    isClearBgColor: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasDrew: false,
      resultImg: '',
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      isDrawing: false,
      sratio: 1
    };
  },

  computed: {
    ratio: function ratio() {
      return this.height / this.width;
    },
    stageInfo: function stageInfo() {
      return this.$refs.canvas.getBoundingClientRect();
    },
    myBg: function myBg() {
      return this.bgColor ? this.bgColor : 'rgba(255, 255, 255, 0)';
    }
  },
  watch: {
    'myBg': function myBg(newVal) {
      this.$refs.canvas.style.background = newVal;
    }
  },
  beforeMount: function beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler);
  },
  mounted: function mounted() {
    var _this = this;

    var canvas = this.$refs.canvas;
    canvas.height = this.height;
    canvas.width = this.width;
    canvas.style.background = this.myBg;
    this.$_resizeHandler();
    // 在画板以外松开鼠标后冻结画笔
    document.onmouseup = function () {
      _this.isDrawing = false;
    };
  },

  methods: {
    $_resizeHandler: function $_resizeHandler() {
      var canvas = this.$refs.canvas;
      canvas.style.width = this.width + "px";
      var realw = parseFloat(window.getComputedStyle(canvas).width);
      canvas.style.height = this.ratio * realw + "px";
      this.canvasTxt = canvas.getContext('2d');
      this.canvasTxt.scale(1 * this.sratio, 1 * this.sratio);
      this.sratio = realw / this.width;
      this.canvasTxt.scale(1 / this.sratio, 1 / this.sratio);
    },

    // pc
    mouseDown: function mouseDown(e) {
      e = e || event;
      e.preventDefault();
      this.isDrawing = true;
      this.hasDrew = true;
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawStart(obj);
    },
    mouseMove: function mouseMove(e) {
      e = e || event;
      e.preventDefault();
      if (this.isDrawing) {
        var obj = {
          x: e.offsetX,
          y: e.offsetY
        };
        this.drawMove(obj);
      }
    },
    mouseUp: function mouseUp(e) {
      e = e || event;
      e.preventDefault();
      var obj = {
        x: e.offsetX,
        y: e.offsetY
      };
      this.drawEnd(obj);
      this.isDrawing = false;
    },

    // mobile
    touchStart: function touchStart(e) {
      e = e || event;
      e.preventDefault();
      this.hasDrew = true;
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawStart(obj);
      }
    },
    touchMove: function touchMove(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawMove(obj);
      }
    },
    touchEnd: function touchEnd(e) {
      e = e || event;
      e.preventDefault();
      if (e.touches.length === 1) {
        var obj = {
          x: e.targetTouches[0].clientX - this.$refs.canvas.getBoundingClientRect().left,
          y: e.targetTouches[0].clientY - this.$refs.canvas.getBoundingClientRect().top
        };
        this.drawEnd(obj);
      }
    },

    // 绘制
    drawStart: function drawStart(obj) {
      this.startX = obj.x;
      this.startY = obj.y;
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
    },
    drawMove: function drawMove(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.strokeStyle = this.lineColor;
      this.canvasTxt.lineWidth = this.lineWidth * this.sratio;
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.startY = obj.y;
      this.startX = obj.x;
      this.points.push(obj);
    },
    drawEnd: function drawEnd(obj) {
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.lineCap = 'round';
      this.canvasTxt.lineJoin = 'round';
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
      this.points.push({ x: -1, y: -1 });
    },

    // 操作
    generate: function generate() {
      var _this2 = this;

      var pm = new Promise(function (resolve, reject) {
        if (!_this2.hasDrew) {
          reject('Warning: Not Signned!');
          return;
        }
        var resImgData = _this2.canvasTxt.getImageData(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.globalCompositeOperation = "destination-over";
        _this2.canvasTxt.fillStyle = _this2.myBg;
        _this2.canvasTxt.fillRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.resultImg = _this2.$refs.canvas.toDataURL();
        var resultImg = _this2.resultImg;
        _this2.canvasTxt.clearRect(0, 0, _this2.$refs.canvas.width, _this2.$refs.canvas.height);
        _this2.canvasTxt.putImageData(resImgData, 0, 0);
        _this2.canvasTxt.globalCompositeOperation = "source-over";
        if (_this2.isCrop) {
          var _canvasTxt;

          var crop_area = _this2.getCropArea(resImgData.data);
          var crop_canvas = document.createElement('canvas');
          var crop_ctx = crop_canvas.getContext('2d');
          crop_canvas.width = crop_area[2] - crop_area[0];
          crop_canvas.height = crop_area[3] - crop_area[1];
          var crop_imgData = (_canvasTxt = _this2.canvasTxt).getImageData.apply(_canvasTxt, _toConsumableArray(crop_area));
          crop_ctx.globalCompositeOperation = "destination-over";
          crop_ctx.putImageData(crop_imgData, 0, 0);
          crop_ctx.fillStyle = _this2.myBg;
          crop_ctx.fillRect(0, 0, crop_canvas.width, crop_canvas.height);
          resultImg = crop_canvas.toDataURL();
          crop_canvas = null;
        }
        resolve(resultImg);
      });
      return pm;
    },
    reset: function reset() {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      if (this.isClearBgColor) {
        this.$emit('update:bgColor', '');
        this.$refs.canvas.style.background = 'rgba(255, 255, 255, 0)';
      }
      this.points = [];
      this.hasDrew = false;
      this.resultImg = '';
    },
    getCropArea: function getCropArea(imgData) {
      var topX = this.$refs.canvas.width;var btmX = 0;var topY = this.$refs.canvas.height;var btnY = 0;
      for (var i = 0; i < this.$refs.canvas.width; i++) {
        for (var j = 0; j < this.$refs.canvas.height; j++) {
          var pos = (i + this.$refs.canvas.width * j) * 4;
          if (imgData[pos] > 0 || imgData[pos + 1] > 0 || imgData[pos + 2] || imgData[pos + 3] > 0) {
            btnY = Math.max(j, btnY);
            btmX = Math.max(i, btmX);
            topY = Math.min(j, topY);
            topX = Math.min(i, topX);
          }
        }
      }
      topX++;
      btmX++;
      topY++;
      btnY++;
      var data = [topX, topY, btmX, btnY];
      return data;
    }
  }
});

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(19);

var _vueQr = __webpack_require__(243);

var _vueQr2 = _interopRequireDefault(_vueQr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { VueQr: _vueQr2.default },
  props: {
    token: {
      type: String,
      default: ''
    },
    imgDialog: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    imgDialog: function imgDialog(val) {
      if (val === true) {
        this.startPolling();
        this.handleReset();
      } else {
        this.stopPolling();
      }
    }
  },
  created: function created() {
    this.startPolling();
    this.handleReset();
  },

  data: function data() {
    return {
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      resultImg: "",
      openId: "",
      isCrop: false,
      borders: "1px solid red",
      text: "https://fw.ceprei.com/service/wx/consignSignRedirect.do?token=" + this.token,
      myInterval: null
    };
  },


  methods: {
    startPolling: function startPolling() {
      var _this = this;

      this.myInterval = window.setInterval(function () {
        setTimeout(function () {
          if (_this.imgDialog !== true) {
            _this.stopPolling();
          }
          _this.getbast64();
        }, 1);
      }, 1000);
    },
    stopPolling: function stopPolling() {
      clearInterval(this.myInterval);
      this.myInterval = null;
    },
    handleReset: function handleReset() {
      this.$refs.esign.reset();
    },
    creatimg: function creatimg() {
      var _this2 = this;

      this.$refs.esign.generate().then(function (res) {
        _this2.resultImg = res;
        _this2.stopPolling();
      }).catch(function (err) {
        _this2.$alert('没有签名,请签名', { dangerouslyUseHTMLString: true, showCancelButton: true, lockScroll: false });
      });
    },
    getbast64: function getbast64() {
      var _this3 = this;

      (0, _api.getImageName)('https://fw.ceprei.com/service/app/sign/getSign', { 'token': this.token }).then(function (response) {
        var obj = response['data'];
        if (!(obj === undefined || obj === '' || obj === null)) {
          _this3.resultImg = obj.base64Img;
          _this3.openId = obj.openId;
          console.log("this.openId=" + _this3.openId);
        }
      }).catch(function (error) {
        console.log(error + '微信获取签名失败', '请求错误');
      });
    },
    handleGenerate: function handleGenerate() {
      var _this4 = this;

      this.$refs.esign.generate().then(function (res) {
        _this4.resultImg = res;
        _this4.stopPolling();
        _this4.getImgr();
      }).catch(function (err) {
        if (_this4.resultImg === '') {
          _this4.$alert('没有签名,请签名', { dangerouslyUseHTMLString: true, showCancelButton: true, lockScroll: false });
        } else {
          _this4.getImgr();
          _this4.stopPolling();
        }
      });
    },
    getImgr: function getImgr() {
      var _this5 = this;

      var file = this.dataURLtoFile(this.resultImg);
      var formData = new FormData();
      formData.append('file', file);
      (0, _api.updateFIle)('https://fw.ceprei.com/service/image/save', formData).then(function (response) {
        _this5.resultImg = '';
        _this5.$emit('callback', { imgUrl: response, openId: _this5.openId });
      }).catch(function (error) {
        console.log(error + '微信获取签名失败', '请求错误');
      });
    },
    dataURLtoFile: function dataURLtoFile(dataurl) {
      var filename = 'lsdkfjalkejl.png';
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }
  }
};

/***/ }),

/***/ 585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(19);

exports.default = {
  data: function data() {
    return {
      sysName: "五所业务服务平台",
      sysNo: "v1.0.0",
      collapsed: false,
      sysUserName: "",
      sysUserAvatar: "",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      roleData: [],
      isUserRequestCertificate: false,
      isNotUserRequestCertificateClass: "container"
    };
  },

  created: function created() {
    var _this2 = this;

    (0, _api.RequestGet)("/user/findCustomer").then(function (response) {
      console.log(_this2.$route.path);
      _this2.sysUserName = response.data.userName;

      sessionStorage.setItem("userId", response.data.id);
      sessionStorage.setItem("loginName", response.data.phone);
      sessionStorage.setItem("type", response.data.type);
      sessionStorage.setItem("enterpriseId", response.data.enterpriseId);
      _this2.isUserRequestCertificate = true, _this2.isNotUserRequestCertificateClass = "container";

      _this2.sysUserAvatar = "";

      _this2.roleData = [{
        id: "1e70c451586649fea1a0676c8db0d79f",
        resName: "个人信息",
        resPath: "#",
        parentId: "e6855215d11a448ca7f3564448c967a1",
        resIcon: null,
        resDesc: null,
        resOpen: "10",
        resSort: 3,
        state: "10",
        selected: true,
        children: [{
          id: "3c6a7d533db244d9b3054081602c6f35",
          resName: "个人信息修改",
          resPath: "modify",
          parentId: "1e70c451586649fea1a0676c8db0d79f",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 1,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "8043570112d045c7a66f7720ccb919ca",
          resName: "绑定所属公司",
          resPath: "affiliate_company",
          parentId: "1e70c451586649fea1a0676c8db0d79f",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 2,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "a2125457cc394dbd913eb5ffbb371996",
          resName: "收货地址管理",
          resPath: "cumstomer_addrList",
          parentId: "1e70c451586649fea1a0676c8db0d79f",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 2,
          state: "10",
          selected: true,
          children: null
        }]
      }, {
        id: "08c5e2e2f38c46618df24ab72a91ff24",
        resName: "委托管理",
        resPath: "#",
        parentId: "e6855215d11a448ca7f3564448c967a1",
        resIcon: null,
        resDesc: null,
        resOpen: "10",
        resSort: 4,
        state: "10",
        selected: true,
        children: [{
          id: "f15aad4c09724ccdbe1aa84f3fe4b72f",
          resName: "委托下单",
          resPath: "chooseDept",
          parentId: "08c5e2e2f38c46618df24ab72a91ff24",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 1,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "cfca587d7c71424baea2df134a5afe74",
          resName: "委托查询",
          resPath: "consignationQuery",
          parentId: "08c5e2e2f38c46618df24ab72a91ff24",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 2,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "cfca587d7c71424bae123df134a5afe73",
          resName: "证书报告防伪验证中心",
          resPath: "/certificate",
          parentId: "08c5e2e2f38c46618df24ab72a91ff24",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 3,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "cfca587d7c71424bae123df134a5af100",
          resName: "企业信息",
          resPath: "/enterprise",
          parentId: "08c5e2e2f38c46618df24ab72a91ff24",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 3,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "cfca587d7c71424bae123df134a5afe75",
          resName: "证书报告防伪验证中心",
          resPath: "/emailConSign",
          parentId: "08c5e2e2f38c46618df24ab72a91ff24",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 3,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "cfca587d7c71424bae123df134a5afe76",
          resName: "证书报告防伪验证中心",
          resPath: "/quoteSignature",
          parentId: "08c5e2e2f38c46618df24ab72a91ff24",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 3,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "cfca587d7c71424bae123df134a5afe77",
          resName: "问卷调查",
          resPath: "/questionnaire",
          parentId: "08c5e2e2f38c46618df24ab72a91ff24",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 3,
          state: "10",
          selected: true,
          children: null
        }]
      }, {
        id: "7a08017009e5428c878ba3ffb358b37c",
        resName: "来访预约",
        resPath: "#",
        parentId: "e6855215d11a448ca7f3564448c967a1",
        resIcon: null,
        resDesc: null,
        resOpen: "10",
        resSort: 5,
        state: "10",
        selected: true,
        children: [{
          id: "dfc9c27eb52142098817b0bb54d42bd5",
          resName: "预约登记",
          resPath: "appointment",
          parentId: "7a08017009e5428c878ba3ffb358b37c",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 1,
          state: "10",
          selected: true,
          children: null
        }, {
          id: "858cec37f8cd49bfbadf67ddb6131bf2",
          resName: "预约记录",
          resPath: "record",
          parentId: "7a08017009e5428c878ba3ffb358b37c",
          resIcon: null,
          resDesc: null,
          resOpen: "10",
          resSort: 2,
          state: "10",
          selected: true,
          children: null
        }]
      }];
    }).catch(function (error) {
      if (_this2.$route.path === "/emailConSign" || _this2.$route.path === "/quoteSignature" || _this2.$route.path === "/questionnaire" || _this2.$route.path === "/enterprise") {
        _this2.isUserRequestCertificate = false, _this2.isNotUserRequestCertificateClass = "";
      } else if (_this2.$route.path != "/certificate") {
        _this2.$router.push({ path: "/certificate" });
      } else {
        _this2.isUserRequestCertificate = false, _this2.isNotUserRequestCertificateClass = "";
      }
    });
  },
  methods: {
    onSubmit: function onSubmit() {
      console.log("submit!");
    },
    handleopen: function handleopen() {},
    handleclose: function handleclose() {},

    handleselect: function handleselect(a, b) {},

    updatePwd: function updatePwd() {
      var _this = this;
      _this.$router.push("/updatePwd1");
    },

    logout: function logout() {
      var _this = this;
      this.$confirm("确认退出吗?", "提示", {}).then(function () {
        sessionStorage.removeItem("user");
        _this.$router.push("/login");
      }).catch(function () {});
    },

    collapse: function collapse() {
      this.collapsed = !this.collapsed;
    },
    showMenu: function showMenu(i, status) {
      this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
    }
  },
  mounted: function mounted() {}
};

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(174);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: 'admin',
        checkPass: '123456'
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true,
      data: {
        loginName: "",
        password: "",
        imgKey: "",
        picCode: ""
      },
      imgStr: ""
    };
  },

  created: function created() {
    this.loadImg();
  },
  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    loadImg: function loadImg() {
      var _this2 = this;

      (0, _api.RequestGet)("/login/loadImgCode").then(function (response) {
        _this2.imgStr = "data:image/jpg;base64," + response.data;
      }).catch(function (error) {});
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this3 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {

          _this3.logining = true;

          (0, _api.RequestPost)("/login/loginUserIn", _this3.data).then(function (response) {

            _this3.logining = false;
            if (response.code == '0000') {
              sessionStorage.setItem('user', (0, _stringify2.default)(response.data));
              sessionStorage.setItem('token', response.data);

              _this3.$router.push({ path: '/homeIndex' });
            } else if (response.code == "2222") {
              var _this = _this3;
              _this.$router.push("/updatePwd1");
              _this3.$message({
                message: response.message,
                type: "warning"
              });
            } else {
              _this3.$message({
                message: response.message,
                type: 'error'
              });
            }
          }).catch(function (error) {
            _this3.$router.push({ path: '/login' });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};

/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(19);

var _format = __webpack_require__(172);

exports.default = {
    data: function data() {
        return {
            total: 0,
            totalsize: 0,
            currentPage: 1,
            page: {
                pageSize: _api.PageSize,
                criteria: '',
                loginId: sessionStorage.getItem("userId")
            },
            tableData: [],
            formcolWidth: '120px',
            dialogFormVisible: false
        };
    },

    methods: {
        appoint: _format.appoint,
        handleSizeChange: function handleSizeChange(val) {
            console.log('\u6BCF\u9875 ' + val + ' \u6761');
        },
        handleCurrentChange: function handleCurrentChange(val) {
            console.log('\u5F53\u524D\u9875: ' + val);
            this.pageNumber = val;
            this.page.pageNumber = val;
            this.loadData();
        },
        loadData: function loadData() {
            var _this = this;

            (0, _api.RequestGet)('/visit/findById', this.page).then(function (response) {
                console.log(response);
                _this.tableData = response.data;
                _this.total = response.page.totalCount;
                _this.totalsize = response.page.pageSize;
            }).catch(function (error) {});
        },
        deleteRow: function deleteRow(index, rows) {
            var _this2 = this;

            this.$confirm('是否确认删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                _this2.dialogFormVisible = false;
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        edit: function edit(index, rows) {
            this.dialogFormVisible = true;
            this.form = rows;
        },
        add: function add() {
            this.$router.push({ path: '/appointment' });
        },
        getUsers: function getUsers() {},
        open2: function open2() {
            var _this3 = this;

            this.$confirm('是否修改该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this3.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                _this3.dialogFormVisible = false;
            }).catch(function () {
                _this3.$message({
                    type: 'info',
                    message: '已取消修改'
                });
            });
        },
        formatterColumn: function formatterColumn(row, column) {
            switch (row.state) {

                case "10":
                    return '审核通过';
                    break;

                case "20":
                    return '待审核';
                    break;

                default:
                    return '未知';
            }
        }
    },
    created: function created() {
        this.loadData();
    }

};

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(19);

exports.default = {
  data: function data() {
    return {
      form: {
        visitor: "",
        visitorIdcard: "",
        visitorDep: "",
        visitorPhone: "",
        visitTime: "",
        visitContent: "",
        visitedPerson: "",
        visitedDep: "",
        visitPerson: "",
        financeCode: ""
      },
      userInfo: [],
      ifHide: true,
      organizes: [],
      id: "",
      name: "",
      dep: "",
      dept: "",
      compare: "",
      show: false,
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      } };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.compare != "") {
        this.form.visitedPerson = this.compare;
      } else {
        this.form.visitedPerson = this.name;
      }
      console.log(sessionStorage);

      (0, _api.RequestPost)("/visit/saveVisitInfo", this.form).then(function (response) {
        console.log(_this.form);
        if (response.code == "0000") {
          _this.$message({
            message: response.message,
            type: "success"
          });
          _this.$router.push({ path: "/record" });
        } else {
          _this.$message({
            message: response.message,
            type: "error"
          });
        }
      });
    },
    getUsers: function getUsers() {
      var _this2 = this;

      this.name = this.form.visitedPerson;
      var person = {
        name: this.name,
        dep: this.form.financeCode };
      if (!(this.name == "" || this.form.financeCode == "")) {
        (0, _api.RequestGet)("/user/findByName", person).then(function (response) {
          if (response.data.length == 0) {
            _this2.$message({ message: "查无此人，请重新输入", type: "error" });
            _this2.ifHide = true;
            _this2.show = false;
          }
          if (response.data.length == 1) {
            _this2.$message({ message: "查找成功", type: "success" });
            response.data.forEach(function (element) {
              _this2.name = element.id;
            });
            _this2.ifHide = false;
            _this2.show = false;
          }
          if (response.data.length > 1) {
            _this2.$message({ message: "查找成功", type: "success" });
            _this2.userInfo = response.data;
            _this2.show = true;
            _this2.ifHide = false;
          }
        }).catch(function (error) {});
      }
    },
    getOrganize: function getOrganize() {
      var _this3 = this;

      this.$axios.post(_api.url + "/visit/findDept").then(function (response) {
        _this3.organizes = JSON.parse(response.data.data).data;
      }).catch(function (error) {});
    },
    getLoginInfo: function getLoginInfo() {
      var _this4 = this;

      this.id = sessionStorage.getItem("userId");
      this.form.visitPerson = sessionStorage.getItem("userId");
      var person = {
        id: this.id
      };
      (0, _api.RequestGet)("/customer/findByid", person).then(function (response) {
        console.log(response);
        _this4.form.visitor = response.data.name;
        _this4.form.visitorIdcard = response.data.idcard;
        _this4.form.visitorDep = response.data.enterpriseName;
        _this4.form.visitorPhone = response.data.phone;
      }).catch(function (error) {});
    },
    selectGet: function selectGet(vId) {
      var obj = {};
      obj = this.organizes.find(function (org) {
        return org.FinanceCode === vId;
      });
      this.form.visitedDep = obj.OrgName;
      this.getUsers();
    }
  },
  created: function created() {
    this.getLoginInfo();
    this.getOrganize();
  }
};

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _echarts = __webpack_require__(852);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            chartColumn: null,
            chartBar: null,
            chartLine: null,
            chartPie: null
        };
    },


    methods: {
        drawColumnChart: function drawColumnChart() {
            this.chartColumn = _echarts2.default.init(document.getElementById('chartColumn'));
            this.chartColumn.setOption({
                title: { text: 'Column Chart' },
                tooltip: {},
                xAxis: {
                    data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'bar',
                    data: [5, 20, 36, 10, 10, 20]
                }]
            });
        },
        drawBarChart: function drawBarChart() {
            this.chartBar = _echarts2.default.init(document.getElementById('chartBar'));
            this.chartBar.setOption({
                title: {
                    text: 'Bar Chart',
                    subtext: '数据来自网络'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['2011年', '2012年']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01]
                },
                yAxis: {
                    type: 'category',
                    data: ['巴西', '印尼', '美国', '印度', '中国', '世界人口(万)']
                },
                series: [{
                    name: '2011年',
                    type: 'bar',
                    data: [18203, 23489, 29034, 104970, 131744, 630230]
                }, {
                    name: '2012年',
                    type: 'bar',
                    data: [19325, 23438, 31000, 121594, 134141, 681807]
                }]
            });
        },
        drawLineChart: function drawLineChart() {
            this.chartLine = _echarts2.default.init(document.getElementById('chartLine'));
            this.chartLine.setOption({
                title: {
                    text: 'Line Chart'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['邮件营销', '联盟广告', '搜索引擎']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name: '邮件营销',
                    type: 'line',
                    stack: '总量',
                    data: [120, 132, 101, 134, 90, 230, 210]
                }, {
                    name: '联盟广告',
                    type: 'line',
                    stack: '总量',
                    data: [220, 182, 191, 234, 290, 330, 310]
                }, {
                    name: '搜索引擎',
                    type: 'line',
                    stack: '总量',
                    data: [820, 932, 901, 934, 1290, 1330, 1320]
                }]
            });
        },
        drawPieChart: function drawPieChart() {
            this.chartPie = _echarts2.default.init(document.getElementById('chartPie'));
            this.chartPie.setOption({
                title: {
                    text: 'Pie Chart',
                    subtext: '纯属虚构',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                },
                series: [{
                    name: '访问来源',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: [{ value: 335, name: '直接访问' }, { value: 310, name: '邮件营销' }, { value: 234, name: '联盟广告' }, { value: 135, name: '视频广告' }, { value: 1548, name: '搜索引擎' }],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            });
        },
        drawCharts: function drawCharts() {
            this.drawColumnChart();
            this.drawBarChart();
            this.drawLineChart();
            this.drawPieChart();
        }
    },

    mounted: function mounted() {
        this.drawCharts();
    },
    updated: function updated() {
        this.drawCharts();
    }
};

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(19);

exports.default = {
	data: function data() {

		return {
			errResult: '',
			reportCodeSeach: '',
			checkCodeSeach: '',
			seachShow: true,

			data: {}
		};
	},

	created: function created() {

		document.title = '中国赛宝官方网站-证书报告验证中心';
	},
	methods: {
		verify: function verify(data) {
			if (data.reportCodeSeach == '') {
				return '请输入查询编号';
			}
			if (data.checkCodeSeach == '') {
				return '请输入验证码';
			}
			return null;
		},
		loadData: function loadData(id) {
			var _this = this;

			this.errResult = '';
			var requestData = { reportCodeSeach: this.reportCodeSeach, checkCodeSeach: this.checkCodeSeach };
			var msg = this.verify(requestData);
			if (msg != null) {
				this.$alert(msg, '填写错误', { lockScroll: false });
				return;
			}
			(0, _api.RequestGet)("/weixin/getCertReportProveResultById", requestData).then(function (response) {
				if (response['data'] == '' || response['data'] == undefined) {
					_this.$alert("内部证书编号：未查询到信息,如有疑问请进一步联系相关业务人员，谢谢！", '证书无效', { dangerouslyUseHTMLString: true, showCancelButton: true, lockScroll: false });
					_this.resultShow = false;
					_this.seachShow = true;
					return;
				}

				var obj1 = JSON.parse(response['data']);
				var obj = obj1['data'];
				if (obj == undefined || obj['ReportCode'] == undefined) {
					_this.$alert('内部证书编号：未查询到信息,如有疑问请进一步联系相关业务人员，谢谢！', '证书无效', { dangerouslyUseHTMLString: true, showCancelButton: true, lockScroll: false });
					_this.resultShow = false;
					_this.seachShow = true;
					return;
				} else {
					_this.resultShow = true;
					_this.seachShow = false;
					_this.data = obj;
					if (_this.data.IssueDate != '' && _this.data.IssueDate != undefined && _this.data.IssueDate != null) {
						_this.data.IssueDate = _this.data.IssueDate.split(' ')[0];
					}
				}
			}).catch(function (error) {
				_this.resultShow = false;
				_this.seachShow = true;
				_this.$alert('请求失败,请联系相关业务人员', '请求错误', { lockScroll: false });
			});
		}
	}

};

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(19);

exports.default = {
	data: function data() {
		return {
			form: {
				visitor: '',
				visitorIdcard: '',
				visitorDep: '',
				visitTime: '',
				visitContent: '部门简介：。。。。。。。。。。。。。。。。。。。。。。。。。。',
				visitedPerson: '',
				visitedDep: ''
			},
			rules: {
				visitedDep: [{
					required: true,
					message: "部门不能为空",
					trigger: "blur" }]
			},
			ifHide: true,
			organizes: [],
			dialogVisible: false
		};
	},

	methods: {
		onSubmit: function onSubmit(form) {
			console.log(this.form);
			if (this.form.visitedDep == "" || this.form.visitedDep == null) {
				this.dialogVisible = true;
			} else {
				this.$router.push({ path: '/commission_order', query: { depId: this.form.visitedDep } });
			}
		},
		getOrganize: function getOrganize() {
			var _this = this;

			this.$axios.get(_api.url + "/deptInfor/findAll").then(function (response) {
				_this.organizes = response.data.data.list;
			}).catch(function (error) {});
		},
		getLoginInfo: function getLoginInfo() {
			var _this2 = this;

			this.id = sessionStorage.getItem("userId");
			this.form.visitPerson = sessionStorage.getItem("userId");
			var person = {
				id: this.id
			};
			RequestGet("/customer/findByid", person).then(function (response) {
				console.log(response);
				_this2.form.visitor = response.data.name;
				_this2.form.visitorIdcard = response.data.idcard;
				_this2.form.visitorDep = response.data.enterpriseName;
				_this2.form.visitorPhone = response.data.phone;
			}).catch(function (error) {});
		},
		handleClose: function handleClose(done) {
			this.$confirm('确认关闭？').then(function (_) {
				done();
			}).catch(function (_) {});
		}
	},
	created: function created() {
		this.getOrganize();
	}
};

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(174);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(263);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(262);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(19);

var _esign = __webpack_require__(516);

var _esign2 = _interopRequireDefault(_esign);

var _vueQr = __webpack_require__(243);

var _vueQr2 = _interopRequireDefault(_vueQr);

var _Table = __webpack_require__(517);

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { esign: _esign2.default, vueQr: _vueQr2.default },
  data: function data() {
    return {
      files: [],
      data: {
        serialNumber: "",
        type: "",
        clientName: "",
        clientContacts: "",
        clientAddr: "",
        clientPhone: "",
        clientMail: "",
        clientFax: "",
        producerName: "",
        producerContacts: "",
        producerAddr: "",
        producerPhone: "",
        producerMail: "",
        producerFax: "",
        factoryName: "",
        factoryContacts: "",
        factoryAddr: "",
        factoryPhone: "",
        factoryMail: "",
        factoryFax: "",
        agentName: "",
        agentContacts: "",
        agentAddr: "",
        agentPhone: "",
        agentMail: "",
        agentFax: "",
        payerName: "",
        payerContacts: "",
        payerAddr: "",
        payerPhone: "",
        payerMail: "",
        payerFax: "",
        paymentMethod: "",
        paymentMethodOrder: "",
        payDate: "",
        receiverName: "",
        receiverContacts: "",
        receiverAddr: "",
        receiverPhone: "",
        receiverMail: "",
        receiverFax: "",
        subData: [],
        simpleSubmitMethod: "",
        simpleSubmitMethodOrder: "",
        providePartsMaterial: "",
        basis: "",
        items: "",
        conditionsRequirements: "",
        agreeSubcontract: "",
        lawsuit: "",
        reportType: "",
        reportForm: "",
        cmaCnas: "",
        serviceRequitements: "",
        reportRemark: "",
        sampleHandle: "",
        sampleHandleOrder: "",
        authorizer: '',
        authorizationTime: '',
        signaturelink: '',
        signer: '',
        signaturetime: '',
        openId: '',
        userId: '',
        id: '',
        attachMent: [],
        authorizerLink: '',
        sampleHandleReturn: '',
        sampleHandleReturnOther: '',
        reportReceiving: '',
        reportReceivingOther: '' },
      inputStyle: '',
      sampleInputStyle: '',
      sampleMethodInputStyle: '',
      sampleHandleReturnOtherStyle: '',
      reportReceivingOtherStyle: '',
      imgDialog: false,
      isRedeoly: false,
      isShow: true
    };
  },

  watch: {
    "data.paymentMethod": function dataPaymentMethod(val) {
      if (this.data.paymentMethod !== '3') {
        this.data.paymentMethodOrder = '';
        this.inputStyle = "border:none";
      } else {
        this.inputStyle = "border:solid red;border-left:0px;border-top:0px;border-right:0px; height:30px;margin-top:-10px;margin-left:-30px; margin-right:30px;";
      }
    },
    "data.simpleSubmitMethod": function dataSimpleSubmitMethod(val) {
      if (this.data.simpleSubmitMethod !== '3') {
        this.data.simpleSubmitMethodOrder = '';
        this.sampleInputStyle = "border:none";
      } else {
        this.sampleInputStyle = "border:solid red ;border-left:0px;border-top:0px;border-right:0px; margin-left:-30px; height:30px;;outline:medium;";
      }
    },
    "data.sampleHandle": function dataSampleHandle(val) {
      if (this.data.sampleHandle !== '6') {
        this.data.sampleHandleReturn = '';
      } else {
        this.sampleMethodInputStyle = "border:solid red;border-left:0px;border-top:0px;border-right:0px; margin-left:-30px; height:20px;";
      }
    },
    "data.sampleHandleReturn": function dataSampleHandleReturn(val) {
      if (this.data.sampleHandleReturn !== '5') {
        this.data.sampleHandleReturnOther = '';
      } else {
        this.sampleHandleReturnOtherStyle = "border:solid red;border-left:0px;border-top:0px;border-right:0px; margin-left:-30px; height:25px;outline: medium;";
      }
    },
    "data.reportReceiving": function dataReportReceiving(val) {
      if (this.data.reportReceiving !== '4') {
        this.data.reportReceivingOther = '';
        if (this.data.reportReceiving == '1') {
          this.data.receiverName = this.data.clientName;
          this.data.receiverAddr = this.data.clientAddr;
          this.data.receiverContacts = this.data.clientContacts;
          this.data.receiverPhone = this.data.clientPhone;
          this.data.receiverMail = this.data.clientMail;
          this.data.receiverFax = this.data.clientFax;
        } else if (this.data.reportReceiving == '2') {
          this.data.receiverName = this.data.agentName;
          this.data.receiverAddr = this.data.agentAddr;
          this.data.receiverContacts = this.data.agentContacts;
          this.data.receiverPhone = this.data.agentPhone;
          this.data.receiverMail = this.data.agentMail;
          this.data.receiverFax = this.data.agentFax;
        } else if (this.data.reportReceiving == '3') {
          this.data.receiverName = this.data.payerName;
          this.data.receiverAddr = this.data.payerAddr;
          this.data.receiverContacts = this.data.payerContacts;
          this.data.receiverPhone = this.data.payerPhone;
          this.data.receiverMail = this.data.payerMail;
          this.data.receiverFax = this.data.payerFax;
        }
      } else {
        this.data.receiverName = '';
        this.data.receiverAddr = '';
        this.data.receiverContacts = '';
        this.data.receiverPhone = '';
        this.data.receiverMail = '';
        this.data.receiverFax = '';
        this.reportReceivingOtherStyle = "border:solid red;border-left:0px;border-top:0px;border-right:0px; margin-left:-30px; height:25px;outline: medium;";
      }
    }

  },
  created: function created() {
    document.title = '中国赛宝实验室装备与整机研究部委托书';
    var prames = '';
    try {
      prames = this.queryToObj(this.$route.fullPath);
    } catch (e) {
      this.isShow = false;
      this.$alert('无效地址,请确认', { dangerouslyUseHTMLString: true, lockScroll: false });
      throw e;
    }
    if (prames !== '') {
      this.getData(prames);
    }
  },
  methods: {
    getData: function getData(requestParam) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _api.RequestPost)("/conSgin/get", requestParam).then(function (response) {
                  if (response.data != '{}') {
                    _this.data = JSON.parse(response.data);
                  }
                  _this.data.userId = _this.data.userId;
                  _this.data.id = _this.data.id;
                  _this.data.reportType = _this.getArr2(_this.data.reportType);
                  _this.data.reportForm = _this.getArr2(_this.data.reportForm);
                  _this.data.cmaCnas = _this.getArr2(_this.data.cmaCnas);
                  if (_this.data.cmaCnas.length === 0) {
                    _this.data.cmaCnas.push('无');
                  }

                  if (_this.data['cmaCnasOther'] === undefined) {
                    _this.data['cmaCnasOther'] = '';
                  }

                  _this.data.pageTye = requestParam.pageTye;
                  _this.data.conId = requestParam.conId;
                  _this.data.timeStamp = requestParam.timeStamp;
                  _this.data.clientDept = requestParam.clientDept;
                  _this.data.authorizer = requestParam.authorizer === undefined ? '' : requestParam.authorizer;
                  _this.data.signaturetime = _this.data.signaturetime === '' ? _this.initTime(new Date()) : _this.data.signaturetime;
                  _this.data.signer = _this.data.signer !== '' ? _this.data.signer : _this.data.agentName != '' && _this.data.agentName != undefined ? _this.data.agentName : _this.data.clientName;

                  _this.isRedeoly = _this.data.signatureType === 'see' || _this.data.signatureType === 'seeEdit' ? true : false;
                }).catch(function (error) {
                  console.log(error);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getArr2: function getArr2(d) {
      if (d === '' || d === undefined) return [];
      return d.split(',');
    },
    receiveSignature: function receiveSignature(img) {
      this.data.signaturelink = img.imgUrl;
      this.data.openId = img.openId;
      console.log(this.data.openId);
      this.imgDialog = false;
    },
    queryToObj: function queryToObj(base64str) {

      var decode = escape(atob(decodeURIComponent(base64str.split('?')[1])));

      var str = decodeURIComponent(decodeURIComponent(decode));
      var res = {};
      str.split('&').forEach(function (paramStr) {
        var arr = paramStr.split('=');
        var key = arr[0];
        var value = arr[1];
        res[key] = value;
      });
      return res;
    },
    upload: function upload() {},
    removeFile: function removeFile(file, fileList) {
      var _this2 = this;

      this.files = [];
      fileList.forEach(function (e) {
        _this2.files.push(e.raw);
        console.log(e.raw.name);
      });
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      this.files.push(file);
      return true;
    },
    deleteFile: function deleteFile(row) {
      var _this3 = this;

      this.$confirm('此操作将暂时删除该文件,提交或暂存以后将永久性删除该文件,是否继续?', '提示', {
        lockScroll: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        row.type = 'delete';
        _this3.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      console.log(row);
    },
    sava: function sava(type) {
      var _this4 = this;

      var data = JSON.parse((0, _stringify2.default)(this.data));
      data.commitType = type;
      var jsonStrData = (0, _stringify2.default)(data);
      var formData = new FormData();
      formData.append('jsonStrData', jsonStrData);
      var isDyMaxFileSize = false;
      var allSize = 0;
      this.files.forEach(function (file) {
        if (file.size > 10485760) {
          isDyMaxFileSize = true;
        }
        allSize += file.size;
        formData.append('files', file);
      });

      if (isDyMaxFileSize) {
        this.$message({ message: '单个文件不可大于10M', type: "error" });
        return;
      }
      if (allSize > 104857600) {
        this.$message({ message: '全部文件不可大于100M', type: "error" });
        return;
      }

      (0, _api.updateFIle)(_api.url + '/conSgin/save', formData).then(function (response) {
        var obj = response['data'];
        var code = response['code'];
        var message = response['message'];
        if (code !== '0000') {
          _this4.$alert(type + '失败' + message, { dangerouslyUseHTMLString: true, lockScroll: false });
        } else {
          _this4.querenkuan(type);
        }
      }).catch(function (error) {
        console.log(error);
        _this4.$alert(type + '失败', { dangerouslyUseHTMLString: true, lockScroll: false });
      });
    },
    querenkuan: function querenkuan(type) {
      var _this5 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this5.$confirm(type + "成功", '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  type: 'success'
                }).then(function () {
                  location.reload();
                }).catch(function () {
                  location.reload();
                });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    submit: function submit(type) {
      var msg = null;
      if (this.data.signatureType === 'seeEdit') {
        msg = this.submitVerifySeeEdit();
      } else if (this.data.signatureType === 'edit') {
        msg = this.submitVerify();
      }
      if (msg !== null) {
        this.$message({ message: msg, type: "error" });
        return;
      }
      this.sava(type);
    },
    initTime: function initTime(date) {
      if (typeof date == 'string') return date;
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var day = date.getDate();
      day = day < 10 ? "0" + day : day;
      return year + '-' + month + '-' + day;
    },
    submitVerify: function submitVerify() {
      var msg = "";

      var d = this.data;
      if (d.clientName === '') return '请填写委托人Client-请填写名称Name';
      if (d.clientAddr === '') return '请填写委托人Client-请填写地址Address';
      if (d.clientContacts === '') return '请填写委托人Client-请填写联系人Contact';
      if (d.clientPhone === '') return '请填写委托人Client-请填写电话Phone';
      if (d.clientMail === '') return '请填写委托人Client-请填写邮箱E-mail';

      if (d.payerName === '') return '请填写交费方Payer-名称Name';
      if (d.payerAddr === '') return '请填写交费方Payer-地址Address';
      if (d.payerContacts === '') return '请填写交费方Payer-联系人Contact';
      if (d.payerPhone === '') return '请填写交费方Payer-电话Phone';
      if (d.payerMail === '') return '请填写交费方Payer-邮箱E-mail';
      if (d.paymentMethod === '') return '请选择交费方Payer-付款方式';
      if (d.paymentMethod === '3' && d.paymentMethodOrder === '') return '请填写交费方Payer-其他付款方式';
      if (d.payDate === '') return '-请选择交费方Payer-付款日期';

      if (d.simpleSubmitMethod === '') return '请选择样品信息- 样品寄送方式';
      if (d.simpleSubmitMethod === '3' && d.simpleSubmitMethodOrder === '') return '请填写样品信息- 样品其他接收方式';
      if (d.subData.length !== 0) {
        for (var i = 0; i < d.subData.length; i++) {
          var element = d.subData[i];
          if (element.name === '') {
            return '请填写样品名称';
          }
          if (element.specs === '') {
            return '请填写样品型号';
          }
          if (element.kind === '') {
            return '请填写样品规格';
          }

          if (element.number === '') {
            return '请填写样品数量';
          }
          if (element.number < 0) {
            return '请填写正确样品数量,样品数量不可小于1';
          }
        }
      }
      if (d.sampleHandle === '') return '请选择样品试验后样品处理Sample Handling';

      if (d.sampleHandle === '6' && d.sampleHandleReturn === '') return '请选着样品处理方式到付寄回的子选项';
      if (d.sampleHandle === '6' && d.sampleHandleReturn === '5' && d.sampleHandleReturnOther === '') return '请选着样品处理方式到付寄回的的相关信息';

      if (d.basis === '') return '请填写检验检测要求- 检验检测依据Testing Basis';
      if (d.items === '') return '请填写检验检测要求- 检验检测项目Test Items';
      if (d.conditionsRequirements === '') return '请填写检验检测要求-检验检测条件及要求Technical Conditions';
      if (d.agreeSubcontract === '') return '请选择检验检测要求-如需分包';
      if (d.lawsuit === '') return '请填写检验检测要求-该检验是否与诉讼有关';

      return this.submitVerifySeeEdit();
    },
    submitVerifySeeEdit: function submitVerifySeeEdit() {
      var msg = "";

      var d = this.data;
      if (d.signer === '') return '填写委托人/代理方名称';
      if (d.signaturelink === '') return '请使用微信扫一扫签名';
      if (d.signaturetime === '') return '请选择委托日期';
      return null;
    }
  }

};

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(19);

exports.default = {
  data: function data() {
    return {
      errResult: "",
      reportCodeSeach: "",
      checkCodeSeach: "",
      seachShow: true,
      unitName: "",
      data: {},
      tableData: []
    };
  },

  created: function created() {
    document.title = "中国赛宝官方网站-证书报告验证中心";
  },
  methods: {
    verify: function verify(data) {
      if (data.unitName == "") {
        return "请输入查询名称";
      }
      return null;
    },
    loadData: function loadData() {
      var _this = this;

      var requestData = { unitName: this.unitName };

      var msg = this.verify(requestData);
      if (msg != null) {
        this.$alert(msg, "填写错误", { lockScroll: false });
        return;
      }

      (0, _api.RequestGet)("/information/findByName", requestData).then(function (response) {
        _this.tableData = response.data;
        _this.seachShow = false;
        console.log(response);
      }).catch(function (error) {});
    },
    cellStyle: function cellStyle() {
      return "background-color: #e6f0f2;color:black;border:1px solid  ";
    },
    headerStyle: function headerStyle() {
      return "background-color: #e6f0f2;color:black;border:1px solid ";
    }
  }
};

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(19);

var reportTypesOptions = ["中文", "英文", "数据"];
var formOptions = [{ value: "1", label: "电子版" }, { value: "2", label: "纸质版(自取)" }, { value: "3", label: "纸质版(快递)" }];
exports.default = {
  data: function data() {
    return {
      form: {
        clientName: "",
        clientAddr: "",
        clientContacts: "",
        clientPhone: "",
        clientMail: "",
        clientFax: "",
        producerName: "",
        producerAddr: "",
        producerContacts: "",
        producerPhone: "",
        producerMail: "",
        producerFax: "",
        factoryName: "",
        factoryAddr: "",
        factoryContacts: "",
        factoryPhone: "",
        factoryMail: "",
        factoryFax: "",
        agentName: "",
        agentAddr: "",
        agentContacts: "",
        agentPhone: "",
        agentMail: "",
        agentFax: "",
        payerName: "",
        payerAddr: "",
        payerContacts: "",
        payerPhone: "",
        payerMail: "",
        payerFax: "",
        receiverName: "",
        receiverAddr: "",
        receiverContacts: "",
        receiverPhone: "",
        receiverMail: "",
        receiverFax: "",
        basis: "",
        items: "",
        lawsuit: "1",
        clientDept: "",
        reportType: ["中文"],
        reportForm: ["1"],
        reportRemark: "",
        sampleHandle: "1",
        subData: [],
        userId: "",
        enterpriseId: "",
        isextranet: "1"
      },
      rules: {
        basis: [{
          required: true,
          message: "检验依据不能为空",
          trigger: "blur" }],
        items: [{
          required: true,
          message: "检验项目不能为空",
          trigger: "blur" }]
      },
      checkedCities: [],
      reportTypes: reportTypesOptions,
      checkedForms: [],
      forms: formOptions,
      checkedWays: [],
      radio: "1",
      radio1: "1",
      lawsuit: "1",
      tableData: [],
      tableData1: [],
      obj: {},
      dialogFormVisible: false,
      formtitle: "",
      index: ""
    };
  },

  methods: {
    onSubmit: function onSubmit(form) {
      var _this = this;

      this.$refs[form].validate(function (valid) {
        if (valid) {
          _this.$confirm("确认下单, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info"
          }).then(function () {
            (0, _api.RequestPost)("/consignation/saveConsignation", _this.form).then(function (response) {
              console.log(_this.form);
              if (response.code == "0000") {
                _this.$message({
                  message: response.message,
                  type: "success"
                });
                清空表单;
                _this.form = {
                  clientName: "",
                  clientAddr: "",
                  clientContacts: "",
                  clientPhone: "",
                  clientMail: "",
                  clientFax: "",
                  basis: "",
                  items: "",
                  lawsuit: "",
                  reportType: [],
                  reportForm: "",
                  reportRemark: "",
                  sampleHandle: ""
                };
                清空表单;
                _this.$router.push({ path: "/consignationQuery" });
              } else {
                _this.$message({
                  message: response.message,
                  type: "error"
                });
              }
            });
          }).catch(function () {
            _this.$message({
              type: "info",
              message: "已取消"
            });
          });
        }
      });
    },
    add: function add() {
      this.obj = {};
      this.dialogFormVisible = true;
      this.formtitle = "新增样品信息";
    },
    open: function open() {
      if (this.formtitle == "新增样品信息") {
        this.tableData1.push(this.obj);
        this.form.subData.push(this.obj);
        this.dialogFormVisible = false;
      }

      if (this.formtitle == "修改样品信息") {
        this.tableData1[this.index].name = this.obj.name;
        this.tableData1[this.index].number = this.obj.number;
        this.tableData1[this.index].specs = this.obj.specs;
        this.tableData1[this.index].trademark = this.obj.trademark;

        this.form.subData[this.index].name = this.obj.name;
        this.form.subData[this.index].number = this.obj.number;
        this.form.subData[this.index].specs = this.obj.specs;
        this.form.subData[this.index].trademark = this.obj.trademark;

        this.dialogFormVisible = false;
      }
    },
    checkinlist: function checkinlist(val) {
      this.reportType = val;
    },
    checkinlist1: function checkinlist1(val) {
      this.reportForm = val;
      console.log(this.reportForm);
    },
    getUserInfo: function getUserInfo() {
      var _this2 = this;

      var person = {
        id: sessionStorage.getItem("userId")
      };
      (0, _api.RequestGet)("/customer/findByid", person).then(function (response) {
        if (response.code == "0000") {
          _this2.form.clientName = response.data.enterpriseName;
          _this2.form.clientAddr = response.data.addr;
          _this2.form.clientContacts = response.data.name;
          _this2.form.clientMail = response.data.email;
          _this2.form.clientPhone = response.data.phone;
        } else {}
      });
    },
    edit: function edit(index, rows) {
      this.formtitle = "修改样品信息";
      this.dialogFormVisible = true;
      this.obj = rows;
      this.index = index;
    },
    deleteRow: function deleteRow(index, rows) {
      this.tableData1.splice(index, 1);
      this.form.subData.splice(index, 1);
    }
  },
  created: function created() {
    this.form.clientDept = this.$route.query.depId;
    this.form.userId = sessionStorage.getItem("userId");
    this.form.enterpriseId = sessionStorage.getItem("enterpriseId");
    this.getUserInfo();
  }
};

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(19);

var _format = __webpack_require__(172);

var checkList = ["非常满意", "比较满意", "一把", "比较不满意", "非常不满意"];
exports.default = {
  methods: {
    dateFormat: _format.dateFormat,
    timeFormat: _format.timeFormat,
    sampleHandle: _format.sampleHandle,
    Whether: _format.Whether,
    state: _format.state,
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 " + val + " \u6761");
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: " + val);
      this.pageNumber = val;

      this.page.pageNumber = val;

      this.loadData();
    },
    query: function query() {
      this.loadData();
    },
    deleteRow: function deleteRow(index, rows) {
      var _this = this;

      this.$confirm("是否确认删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.$message({
          type: "success",
          message: "删除成功!"
        });
        _this.dialogFormVisible = false;
      }).catch(function () {
        _this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    edit: function edit(index, rows) {
      console.log(rows);
      this.dialogFormVisible = true;
      this.form = rows;
    },
    addComplaint: function addComplaint(index, rows) {
      this.dialogFormVisibleComplaint = true;
      this.isEdit = true;
      this.formtitle = "满意度调查";
      this.updateDate = true;
      this.conData.consignationId = rows.id;
    },
    addSatisfaction: function addSatisfaction(index, rows) {
      this.dialogFormVisibleSatisfaction = true;
      this.isEdit = true;
      this.formtitle = "投诉与意见";
      this.updateDate = true;
      this.conData2.consignationId = rows.id;
    },
    add: function add() {
      this.$router.push({ path: "/chooseDept" });
    },
    open2: function open2() {
      var _this2 = this;

      this.$confirm("是否修改该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.$message({
          type: "success",
          message: "修改成功!"
        });
        _this2.dialogFormVisible = false;
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "已取消修改"
        });
      });
    },
    addComplaintalert: function addComplaintalert(conData) {
      var _this3 = this;

      this.$refs[conData].validate(function (valid) {
        if (valid) {
          _this3.$confirm("是否确认添加该满意内容?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            console.log(_this3.conData);
            (0, _api.RequestPost)("/complaint/addComplaint", _this3.conData).then(function (response) {
              if (response.code == "0000") {
                _this3.$message({
                  message: "数据信息保存成功！",
                  type: "success"
                });
                _this3.dialogFormVisibleComplaint = false;
              } else {
                _this3.$message({
                  message: "数据信息保存失败！",
                  type: "error"
                });
              }
              _this3.loadData();
            }).catch(function (error) {});
            _this3.dialogFormVisibleComplaint = false;
          }).catch(function () {
            _this3.$message({
              type: "info",
              message: "已取消删除"
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSatisfactionalert: function addSatisfactionalert(conData2) {
      var _this4 = this;

      this.$refs[conData2].validate(function (valid) {
        if (valid) {
          _this4.$confirm("是否确认添加该满意内容?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(function () {
            console.log(_this4.conData2);
            (0, _api.RequestPost)("/satisfaction/addSatisfaction", _this4.conData2).then(function (response) {
              if (response.code == "0000") {
                _this4.$message({
                  message: "数据信息保存成功！",
                  type: "success"
                });
                _this4.dialogFormVisibleSatisfaction = false;
              } else {
                _this4.$message({
                  message: "数据信息保存失败！",
                  type: "error"
                });
              }
              _this4.loadData();
            }).catch(function (error) {});
            _this4.dialogFormVisibleSatisfaction = false;
          }).catch(function () {
            _this4.$message({
              type: "info",
              message: "已取消删除"
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    formatterColumn: function formatterColumn(row, column) {
      switch (row.state) {
        case "10":
          return "审核通过";
          break;
        case "20":
          return "待审核";
          break;
        default:
          return "未知";
      }
    },
    loadData: function loadData() {
      var _this5 = this;

      (0, _api.RequestGet)("/consignation/findAll", this.page).then(function (response) {
        if (response.code == "0000") {
          console.log(response.data);
          _this5.datalist = response.data;
          _this5.total = response.page.totalCount;
          _this5.totalsize = response.page.pageSize;
        }
      }).catch(function (error) {
        console.log("error");
      });
    },
    downPort: function downPort(index, row) {
      this.href = this.href + row.id;
    }
  },
  created: function created() {
    this.loadData();
  },
  data: function data() {
    return {
      conData: { checkList: "非常满意" },
      conData2: {
        remark: ""
      },

      rules: {
        remark: [{
          required: true,
          message: "满意内容不能为空",
          trigger: "blur" }]
      },
      rules2: {
        remark: [{
          required: true,
          message: "投诉或意见内容不能为空",
          trigger: "blur" }]
      },
      formtitle: "",
      checkLists: checkList,
      datalist: [],
      listLoading: false,
      formcolWidth: "120px",
      dialogFormVisible: false,
      dialogFormVisibleComplaint: false,
      dialogFormVisibleSatisfaction: false,
      total: 0,
      totalsize: 0,
      currentPage: 1,
      href: 'http://fw.ceprei.com/service/consignation/download?uuid=',
      page: {
        pageSize: _api.PageSize,
        criteria: "",
        userId: sessionStorage.getItem("userId"),
        enterpriseId: sessionStorage.getItem("enterpriseId"),
        type: sessionStorage.getItem("type")
      }
    };
  }
};

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(19);

exports.default = {
	data: function data() {
		return {
			errResult: '',
			reportCodeSeach: '',
			checkCodeSeach: '',
			seachShow: true,
			data: {
				pxId: '',
				name: '秦亚军',
				email: '792399923@qq.com',
				pone: '18102801535',
				radio1: '1',
				radio2: '1',
				radio3: '1',
				radio4: '1',
				radio5: '1',
				radio6: '1',
				radio7: '1',
				radio8: '1',

				suggest: '建议1',
				need: '需求2'
			}
		};
	},

	created: function created() {
		document.title = '中国赛宝官方网站-培训满意度评价表';
		this.data.pxId = this.$route.query.pxId;
	},
	methods: {
		saveDiaoCha: function saveDiaoCha() {
			var _this = this;

			var msg = this.verify(this.data);
			if (msg !== null) {
				this.$message({ type: 'error', message: msg });
				return;
			}
			(0, _api.RequestPost)("/weixin/saveDiaoCha", this.data).then(function (response) {
				if (response['data'] == '' || response['data'] == undefined) {
					_this.$alert("提交成功,感谢您的意见", '提示', { dangerouslyUseHTMLString: true, lockScroll: false });
					return;
				}
			}).catch(function (error) {
				_this.resultShow = false;
				_this.seachShow = true;
				_this.$alert('请求失败,请联系相关业务人员', '请求错误', { lockScroll: false });
			});
		},
		verify: function verify(data) {
			if (data.name === '') {
				return '请填写名字';
			}
			if (data.email == '') {
				return '请填写邮箱';
			}
			if (data.pone == '') {
				return '请填写手机号码';
			}
			if (data.radio1 === '') {
				return '请选择选项1';
			}
			if (data.radio2 === '') {
				return '请选择选项2';
			}
			if (data.radio3 === '') {
				return '请选择选项3';
			}
			if (data.radio4 === '') {
				return '请选择选项4';
			}
			if (data.radio5 === '') {
				return '请选择选项5';
			}
			if (data.radio6 === '') {
				return '请选择选项6';
			}
			if (data.radio7 === '') {
				return '请选择选项7';
			}
			if (data.radio8 === '') {
				return '请选择选项8';
			}

			return null;
		}
	}

};

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(174);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(263);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(262);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = __webpack_require__(19);

var _esign = __webpack_require__(516);

var _esign2 = _interopRequireDefault(_esign);

var _vueQr = __webpack_require__(243);

var _vueQr2 = _interopRequireDefault(_vueQr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: { esign: _esign2.default, vueQr: _vueQr2.default },
  data: function data() {
    return {
      list1: [{ name: '' }, { name: '' }, { name: '' }, { name: '' }, { name: '' }],
      data: {
        type: "",
        clientName: "",
        clientContacts: "",
        clientAddr: "",
        clientPhone: "",
        clientMail: "",
        clientFax: "",
        producerName: "",
        producerContacts: "",
        producerAddr: "",
        producerPhone: "",
        producerMail: "",
        producerFax: "",
        factoryName: "",
        factoryContacts: "",
        factoryAddr: "",
        factoryPhone: "",
        factoryMail: "",
        factoryFax: "",
        agentName: "",
        agentContacts: "",
        agentAddr: "",
        agentPhone: "",
        agentMail: "",
        agentFax: "",
        payerName: "",
        payerContacts: "",
        payerAddr: "",
        payerPhone: "",
        payerMail: "",
        payerFax: "",
        paymentMethod: "",
        paymentMethodOrder: "",
        payDate: "",
        receiverName: "",
        receiverContacts: "",
        receiverAddr: "",
        receiverPhone: "",
        receiverMail: "",
        receiverFax: "",
        subData: [],
        simpleSubmitMethod: "",
        simpleSubmitMethodOrder: "",
        providePartsMaterial: "",
        basis: "",
        items: "",
        conditionsRequirements: "",
        agreeSubcontract: "",
        lawsuit: "",
        reportType: "",
        reportForm: "",
        cmaCnas: "",
        serviceRequitements: "",
        reportRemark: "",
        sampleHandle: "",
        sampleHandleOrder: "",
        authorizer: '',
        authorizationTime: '',
        signaturelink: '',
        signer: '',
        signaturetime: '',
        openId: ''
      },
      inputStyle: '',
      sampleInputStyle: '',
      sampleMethodInputStyle: '',
      imgDialog: false,
      isRedeoly: false,
      isShow: true,
      total: 0
    };
  },

  watch: {},
  created: function created() {
    document.title = '中国赛宝实验室装备与整机研究部委托书';
    this.total = 0;
    var prames = '';
    try {
      prames = this.queryToObj(this.$route.fullPath);
    } catch (e) {
      this.isShow = false;
      this.$alert('无效地址,请确认', { dangerouslyUseHTMLString: true, lockScroll: false });
      throw e;
    }
    if (prames !== '') {
      this.getData(prames);
    }
  },
  methods: {
    getData: function getData(requestParam) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _api.RequestPost)("/conSgin/get", requestParam).then(function (response) {
                  if (response.data != '{}') {
                    _this.data = JSON.parse(response.data);
                  }
                  _this.data.reportType = _this.getArr2(_this.data.reportType);
                  _this.data.reportForm = _this.getArr2(_this.data.reportForm);
                  _this.data.cmaCnas = _this.getArr2(_this.data.cmaCnas);
                  _this.data.pageTye = requestParam.pageTye;
                  _this.data.conId = requestParam.conId;
                  _this.data.timeStamp = requestParam.timeStamp;
                  _this.data.clientDept = requestParam.clientDept;
                  _this.data.authorizer = requestParam.authorizer === undefined ? '' : requestParam.authorizer;
                  _this.data.signatureType = 'edit';
                  _this.isRedeoly = _this.data.signatureType === 'see' || _this.data.signatureType === 'seeEdit' ? true : false;
                }).catch(function (error) {
                  console.log(error);
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getArr2: function getArr2(d) {
      if (d === '' || d === undefined) return [];
      return d.split(',');
    },
    receiveSignature: function receiveSignature(img) {
      console.log(img);
      this.data.signaturelink = img.imgUrl;
      this.data.openId = img.openId;
      console.log(this.data.openId);
      this.imgDialog = false;
    },
    queryToObj: function queryToObj(base64str) {
      var decode = escape(atob(base64str.split('?')[1]));
      var str = decodeURIComponent(decodeURIComponent(decode));
      var res = {};
      str.split('&').forEach(function (paramStr) {
        var arr = paramStr.split('=');
        var key = arr[0];
        var value = arr[1];
        res[key] = value;
      });
      return res;
    },
    sava: function sava(type) {
      var _this2 = this;

      var data = JSON.parse((0, _stringify2.default)(this.data));
      data.commitType = type;
      data.userId = '';
      data.id = '';
      (0, _api.RequestPost)("/conSgin/save", data).then(function (response) {
        var obj = response['data'];
        var code = response['code'];
        var message = response['message'];
        if (code !== '0000') {
          _this2.$alert(type + '失败' + message, { dangerouslyUseHTMLString: true, lockScroll: false });
        } else {
          location.reload();
        }
      }).catch(function (error) {
        console.log(error);
        _this2.$alert(type + '失败', { dangerouslyUseHTMLString: true, lockScroll: false });
      });
    },
    submit: function submit(type) {
      var msg = this.submitVerify();
      if (msg !== null) {
        this.$message({ message: msg, type: "error" });
        return;
      }
      this.sava(type);
    },
    initTime: function initTime(date) {
      if (typeof date == 'string') return date;
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var day = date.getDate();
      day = day < 10 ? "0" + day : day;
      return year + '-' + month + '-' + day;
    }
  }
};

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	data: function data() {
		return {
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			}
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			console.log('submit!');
		}
	}
};

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__(261);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(578);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			users: [],
			total: 0,
			page: 1,
			listLoading: false,
			sels: [],

			editFormVisible: false,
			editLoading: false,
			editFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			editForm: {
				id: 0,
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			},

			addFormVisible: false,
			addLoading: false,
			addFormRules: {
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
			},

			addForm: {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			}

		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.page = val;
			this.getUsers();
		},
		getUsers: function getUsers() {
			var _this = this;

			var para = {
				page: this.page,
				name: this.filters.name
			};
			this.listLoading = true;

			(0, _api.getUserListPage)(para).then(function (res) {
				_this.total = res.data.total;
				_this.users = res.data.users;
				_this.listLoading = false;
			});
		},

		handleDel: function handleDel(index, row) {
			var _this2 = this;

			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(function () {
				_this2.listLoading = true;

				var para = { id: row.id };
				(0, _api.removeUser)(para).then(function (res) {
					_this2.listLoading = false;

					_this2.$message({
						message: '删除成功',
						type: 'success'
					});
					_this2.getUsers();
				});
			}).catch(function () {});
		},

		handleEdit: function handleEdit(index, row) {
			this.editFormVisible = true;
			this.editForm = (0, _assign2.default)({}, row);
		},

		handleAdd: function handleAdd() {
			this.addFormVisible = true;
			this.addForm = {
				name: '',
				sex: -1,
				age: 0,
				birth: '',
				addr: ''
			};
		},

		editSubmit: function editSubmit() {
			var _this3 = this;

			this.$refs.editForm.validate(function (valid) {
				if (valid) {
					_this3.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this3.editLoading = true;

						var para = (0, _assign2.default)({}, _this3.editForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.editUser)(para).then(function (res) {
							_this3.editLoading = false;

							_this3.$message({
								message: '提交成功',
								type: 'success'
							});
							_this3.$refs['editForm'].resetFields();
							_this3.editFormVisible = false;
							_this3.getUsers();
						});
					});
				}
			});
		},

		addSubmit: function addSubmit() {
			var _this4 = this;

			this.$refs.addForm.validate(function (valid) {
				if (valid) {
					_this4.$confirm('确认提交吗？', '提示', {}).then(function () {
						_this4.addLoading = true;

						var para = (0, _assign2.default)({}, _this4.addForm);
						para.birth = !para.birth || para.birth == '' ? '' : _util2.default.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
						(0, _api.addUser)(para).then(function (res) {
							_this4.addLoading = false;

							_this4.$message({
								message: '提交成功',
								type: 'success'
							});
							_this4.$refs['addForm'].resetFields();
							_this4.addFormVisible = false;
							_this4.getUsers();
						});
					});
				}
			});
		},
		selsChange: function selsChange(sels) {
			this.sels = sels;
		},

		batchRemove: function batchRemove() {
			var _this5 = this;

			var ids = this.sels.map(function (item) {
				return item.id;
			}).toString();
			this.$confirm('确认删除选中记录吗？', '提示', {
				type: 'warning'
			}).then(function () {
				_this5.listLoading = true;

				var para = { ids: ids };
				(0, _api.batchRemoveUser)(para).then(function (res) {
					_this5.listLoading = false;

					_this5.$message({
						message: '删除成功',
						type: 'success'
					});
					_this5.getUsers();
				});
			}).catch(function () {});
		}
	},
	mounted: function mounted() {
		this.getUsers();
	}
};

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(19);

exports.default = {
    methods: {
        deleteRow: function deleteRow(index, rows) {
            var _this = this;

            this.$confirm('是否确认删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                _this.dialogFormVisible = false;
            }).catch(function () {
                _this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        edit: function edit(index, rows) {
            this.dialogFormVisible = true;
            this.form = rows;
        },
        add: function add() {
            this.dialogFormVisible = true;
        },
        getUsers: function getUsers() {},
        open2: function open2() {
            var _this2 = this;

            this.$confirm('是否修改该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                _this2.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                _this2.dialogFormVisible = false;
            }).catch(function () {
                _this2.$message({
                    type: 'info',
                    message: '已取消修改'
                });
            });
        },
        formatterColumn: function formatterColumn(row, column) {
            switch (row.state) {

                case "10":
                    return '审核通过';
                    break;

                case "20":
                    return '待审核';
                    break;

                default:
                    return '未知';
            }
        }
    },
    created: function created() {
        var _this3 = this;

        this.$axios.get(_api.url + '/community/findAll').then(function (response) {
            _this3.tableData = response.data.data;
            console.log(_this3.tableData);
        }).catch(function (error) {
            console.log(error);
        });
    },
    data: function data() {
        return {
            tableData: [],
            formcolWidth: '120px',
            dialogFormVisible: false
        };
    }
};

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(19);

exports.default = {
	data: function data() {
		return {
			filters: {
				name: ''
			},
			loading: false,
			users: []
		};
	},

	methods: {
		formatSex: function formatSex(row, column) {
			return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
		},

		getUser: function getUser() {
			var _this = this;

			var para = {
				name: this.filters.name
			};
			this.loading = true;

			(0, _api.getUserList)(para).then(function (res) {
				_this.users = res.data.users;
				_this.loading = false;
			});
		}
	},
	mounted: function mounted() {
		this.getUser();
	}
};

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(175);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getCount'])),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['increment', 'decrement']))
};

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(19);

exports.default = {

	methods: {
		handleSizeChange: function handleSizeChange(val) {
			console.log('\u6BCF\u9875 ' + val + ' \u6761');
		},
		handleCurrentChange: function handleCurrentChange(val) {
			var _this = this;

			console.log('\u5F53\u524D\u9875: ' + val);
			this.pageNumber = val;

			this.page.pageNumber = val;

			this.$axios.get(_api.url + '/community/findAll', { params: this.page }).then(function (response) {
				if (response.data.code == '0000') {
					_this.datalist = response.data.data;
					_this.total = response.data.page.totalCount;
					_this.totalsize = response.data.page.pageSize;
				}
			}).catch(function (error) {
				console.log(error);
			});
		},
		deleteRow: function deleteRow(index, rows) {
			var _this2 = this;

			this.$confirm('是否确认删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				_this2.$message({
					type: 'success',
					message: '删除成功!'
				});
				_this2.dialogFormVisible = false;
			}).catch(function () {
				_this2.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		edit: function edit(index, rows) {
			this.dialogFormVisible = true;
			this.form = rows;
		},
		add: function add() {
			this.dialogFormVisible = true;
		},
		getUsers: function getUsers() {},
		open2: function open2() {
			var _this3 = this;

			this.$confirm('是否修改该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				_this3.dialogFormVisible = false;
				_this3.$message({
					type: 'success',
					message: response.data.message
				});

				_this3.dialogFormVisible = false;
			}).catch(function () {
				_this3.$message({
					type: 'info',
					message: '已取消修改'
				});
			});
		},
		loadProvince: function loadProvince() {
			var _this4 = this;

			var page = {
				parentCode: '100000'
			};
			this.$axios.get(_api.url + '/community/findCitys', { params: page }).then(function (response) {
				if (response.data.code == '0000') {
					_this4.provinces = response.data.data;

					for (var opt in _this4.provinces) {
						if (!_this4.form.provinceCode) {
							_this4.form.provinceCode = _this4.provinces[opt].code;
							_this4.form.province = _this4.provinces[opt].name;
							_this4.loadCity(_this4.form.provinceCode);
						}
						break;
					}
				}
			}).catch(function (error) {
				console.log(error);
			});
		},
		loadCity: function loadCity(provinceCode) {
			var _this5 = this;

			var data = {

				parentCode: provinceCode

			};
			this.$axios.get(_api.url + '/community/findCitys', { params: data }).then(function (response) {
				if (response.data.code == '0000') {
					_this5.citys = response.data.data;

					for (var opt in _this5.citys) {
						if (!_this5.form.cityCode) {
							_this5.form.cityCode = _this5.citys[opt].code;
							_this5.form.city = _this5.citys[opt].name;
							_this5.loadArea(_this5.form.cityCode);
						}
						break;
					}
				}
			}).catch(function (error) {
				console.log(error);
			});
		},
		loadArea: function loadArea(cityCode) {
			var _this6 = this;

			var data = {

				parentCode: cityCode

			};

			this.$axios.get(_api.url + '/community/findCitys', { params: data }).then(function (response) {
				if (response.data.code == '0000') {
					_this6.areas = response.data.data;

					for (var opt in _this6.areas) {
						if (!_this6.form.areaCode) {
							_this6.form.areaCode = _this6.areas[opt].code;
							_this6.form.area = _this6.areas[opt].name;
						}
						break;
					}
				}
			}).catch(function (error) {
				console.log(error);
			});
		},
		selectProvince: function selectProvince(obj) {
			this.form.province = obj;
			this.form.cityCode = null;
			this.form.areaCode = null;
			this.loadCity(obj);
		},
		selectCity: function selectCity(obj) {
			this.form.city = obj;
			this.form.areaCode = null;
			this.form.area = null;
			this.loadArea(obj);
		},
		selectArea: function selectArea(obj) {
			this.form.area = obj;
		}
	},

	created: function created() {
		var _this7 = this;

		this.page.pageNumber = 1;
		this.$axios.get(_api.url + '/community/findAll', { params: this.page }).then(function (response) {
			if (response.data.code == '0000') {
				_this7.datalist = response.data.data;
				_this7.total = response.data.page.totalCount;
				_this7.totalsize = response.data.page.pageSize;
			}
		}).catch(function (error) {
			console.log(error);
		});

		this.loadProvince();
	},
	data: function data() {
		return {
			total: 0,
			totalsize: 0,
			currentPage: 1,
			pageNumber: 1,
			datalist: [],
			page: {
				pageSize: 1,
				pageNumber: this.pageNumber },
			listLoading: false,
			form: {},
			dialogFormVisible: false,
			provinces: [],
			citys: [],
			areas: [] };
	}
};

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _api = __webpack_require__(19);

exports.default = {
    methods: {
        deleteRow: function deleteRow(index, rows) {
            var _this = this;

            this.$confirm('是否确认删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                (0, _api.RequestPost)("/main/deleteMenu", rows).then(function (response) {
                    if (response.code == '0000') {
                        _this.$message({
                            message: response.message,
                            type: 'success'
                        });
                        _this.dialogFormVisible = false;
                    } else {
                        _this.$message({
                            message: response.message,
                            type: 'error'
                        });
                    }
                    _this.loadData();
                });
                _this.dialogFormVisible = false;
            }).catch(function () {
                _this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        edit: function edit(index, rows) {
            this.formtitle = "修改菜单";
            this.form = rows;
            this.dialogFormVisible = true;
            this.readonly = true;
        },
        add: function add() {
            this.form = {};
            this.formtitle = "新增菜单";
            this.dialogFormVisible = true;
            this.readonly = false;
        },
        getUsers: function getUsers() {},
        open2: function open2() {
            var _this2 = this;

            if (this.formtitle == "新增菜单") {
                (0, _api.RequestPost)("/main/addMenu", this.form).then(function (response) {
                    console.log(response);
                    if (response.code == '0000') {
                        _this2.$message({
                            message: response.message,
                            type: 'success'
                        });
                    } else {
                        _this2.$message({
                            message: response.message,
                            type: 'error'
                        });
                    }
                    _this2.loadData();
                    _this2.dialogFormVisible = false;
                });
            }
            if (this.formtitle == "修改菜单") {
                (0, _api.RequestPost)("/main/updateMenu", this.form).then(function (response) {
                    console.log(response);
                    if (response.code == "0000") {
                        _this2.$message({
                            message: response.message,
                            type: "success"
                        });
                    } else {
                        _this2.$message({
                            message: response.message,
                            type: "erroe"
                        });
                    }
                    _this2.loadData();
                    _this2.dialogFormVisible = false;
                });
            }
        },
        formatterColumn: function formatterColumn(row, column) {
            switch (row.state) {

                case "10":
                    return '审核通过';
                    break;

                case "20":
                    return '待审核';
                    break;

                default:
                    return '未知';
            }
        },
        loadData: function loadData() {
            var _this3 = this;

            this.$axios.get(_api.url + '/main/findVueMenuAll').then(function (response) {
                _this3.tableData = response.data.data;
            }).catch(function (error) {
                console.log(error);
            });
        }
    },
    created: function created() {
        this.loadData();
    },

    data: function data() {
        return {
            form: {},
            tableData: [],
            formcolWidth: '100',
            dialogFormVisible: false,
            formtitle: "",
            readonly: false
        };
    }
};

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(19);

var _elementChinaAreaData = __webpack_require__(232);

exports.default = {
	data: function data() {
		return {
			page: {
				pageSize: _api.PageSize,
				criteria: '',
				customerId: sessionStorage.getItem("userId") },
			enterpriserVo: {
				name: '',
				legalPerson: '',
				businessScope: '',
				regAddr: '',
				taxpayerType: '',
				taxpayerNum: ''

			},
			options: _elementChinaAreaData.regionData,
			selectedOptions: []
		};
	},

	methods: {
		onSubmit: function onSubmit() {
			var _this = this;

			this.enterpriserVo.userId = sessionStorage.getItem("userId");
			(0, _api.RequestPost)("/enterpriser/saveEnterpriseAndSaveToCustomer", this.enterpriserVo).then(function (response) {
				if (response.code == "0000") {
					_this.$message({
						message: response.message,
						type: 'success'
					});
					_this.loadData();
				} else {
					_this.$message({
						message: response.message,
						type: 'error'
					});
				}
			});
		},
		getEnterpriseByCenterData: function getEnterpriseByCenterData() {
			var _this2 = this;

			(0, _api.RequestPost)("/enterpriser/getEnterpriseByCenterData", this.enterpriserVo).then(function (response) {
				if (response.code == '0000') {
					_this2.enterpriserVo = response.data;
					if (response.code == "0000") {
						vm.$Modal.success({
							title: "提示",
							content: response.message + "无需修改，请直接保存！"
						});
					} else {
						vm.$Modal.success({
							title: "提示",
							content: response.message + "查询成功，请直接保存！"
						});
					}
				}
			}).catch(function (error) {});
		},
		loadData: function loadData() {
			var _this3 = this;

			this.enterpriserVo.userId = sessionStorage.getItem("userId");
			(0, _api.RequestPost)("/enterpriser/getEnterpriseByCustomerEnterpriseID", this.enterpriserVo).then(function (response) {
				_this3.enterpriserVo = response.data;
			});
		},
		handleChange: function handleChange(value) {
			console.log(value);
		}
	},

	created: function created() {
		this.loadData();
	}
};

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(19);

var _elementChinaAreaData = __webpack_require__(232);

exports.default = {
  data: function data() {
    return {
      formtitle: "地址信息",
      listLoading: false,
      dialogFormVisible: false,
      subData: {},
      total: 0,
      currentPage: 1,
      totalsize: 0,
      page: {
        pageSize: _api.PageSize,
        criteria: "",
        customerId: sessionStorage.getItem("userId") },
      datalist: [],
      options: _elementChinaAreaData.regionData,
      selectedOptions: [],
      rules: {
        cnee: [{
          required: true,
          message: "收货人不能为空",
          trigger: "blur" }],
        phone: [{
          required: true,
          message: "手机号不能为空",
          trigger: "blur" }, {
          pattern: /^1[34578]\d{9}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        }],
        addr: [{
          required: true,
          message: "详细地址不能为空",
          trigger: "blur" }],
        area: [{
          required: true,
          message: "所在地区不能为空",
          trigger: "blur" }]
      }
    };
  },


  methods: {
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 " + val + " \u6761");
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: " + val);
      this.pageNumber = val;
      this.page.pageNumber = val;

      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      (0, _api.RequestGet)("/customerAddr/getCustomerAddrList", this.page).then(function (response) {
        if (response.code == "0000") {
          _this.datalist = response.data;
          _this.total = response.page.totalCount;
          _this.totalsize = response.page.pageSize;
        }
      }).catch(function (error) {
        _this.$router.push({ path: "/login" });
      });
    },
    query: function query() {
      this.loadData();
    },
    add: function add() {
      this.dialogFormVisible = true;
      this.formtitle = "新增收货地址";
      this.subData = {};
      this.isEdit = true;
      this.subData = {
        cnee: "",
        phone: "",
        area: "",
        customerId: sessionStorage.getItem("userId"),
        remark: "",
        type: "",
        state: "10"
      };
    },
    editAddr: function editAddr(index, rows) {
      this.dialogFormVisible = true;
      this.formtitle = "修改收货地址";
      this.subData = rows;
    },
    deleteAddr: function deleteAddr(index, rows) {
      var _this2 = this;

      this.$confirm("确认删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.$message({
          type: "success",
          message: "删除成功!"
        });
        (0, _api.RequestPost)("/customerAddr/deleteAddr", rows).then(function (response) {
          if (response.code == "0000") {
            _this2.$message({
              message: response.message,
              type: "success"
            });
            _this2.dialogFormVisible = false;
          } else {
            _this2.$message({
              message: response.message,
              type: "error"
            });
          }
          _this2.loadData();
        }).catch(function (error) {
          _this2.$router.push({ path: "/login" });
        });
        _this2.dialogFormVisible = false;
      }).catch(function () {
        _this2.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    saveAddr: function saveAddr(subData) {
      var _this3 = this;

      this.$refs[subData].validate(function (valid) {
        if (valid) {
          if (_this3.formtitle == "新增收货地址") {
            (0, _api.RequestPost)("/customerAddr/addAddr", _this3.subData).then(function (response) {
              if (response.code == "0000") {
                _this3.$message({
                  message: response.message,
                  type: "success"
                });
                _this3.dialogFormVisible = false;
              } else {
                _this3.$message({
                  message: response.message,
                  type: "error"
                });
              }
              _this3.loadData();
            }).catch(function (error) {
              _this3.$router.push({ path: "/login" });
            });
          } else {
            (0, _api.RequestPost)("/customerAddr/updateCustomerAddr", _this3.subData).then(function (response) {
              if (response.code == "0000") {
                _this3.$message({
                  message: response.message,
                  type: "success"
                });
                _this3.dialogFormVisible = false;
              } else {
                _this3.$message({
                  message: response.message,
                  type: "error"
                });
              }
              _this3.loadData();
            }).catch(function (error) {
              _this3.$router.push({ path: "/login" });
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    check: function check(subData) {
      if (subData.cnee == "") {
        this.$message({
          message: "请输入收货人",
          type: "error"
        });
        return false;
      }
      if (subData.phone == "") {
        this.$message({
          message: "请输入手机",
          type: "error"
        });
        return false;
      }
      var reg = /^1[3456789]\d{9}$/;
      if (!reg.test(subData.phone)) {
        this.$message({
          message: "手机输入不合法",
          type: "error"
        });
        return false;
      }
      if (subData.area == "") {
        this.$message({
          message: "请输入所在地区",
          type: "error"
        });
        return false;
      }
      if (subData.addr == "") {
        this.$message({
          message: "请输入详细地址",
          type: "error"
        });
        return false;
      }
      return true;
    },
    handleChange: function handleChange() {}
  },

  created: function created() {
    this.loadData();
  }
};

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(19);

var _elementChinaAreaData = __webpack_require__(232);

exports.default = {
  data: function data() {
    return {
      form: {
        name: "",
        idcard: "",
        phone: "",
        email: "",
        addr: ""
      },
      rules: {
        name: [{
          required: true,
          message: "姓名不能为空",
          trigger: "blur" }],
        phone: [{
          required: true,
          message: "手机号不能为空",
          trigger: "blur" }, {
          pattern: /^1[34578]\d{9}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        }],
        idcard: [{
          required: true,
          message: "身份证不能为空",
          trigger: "blur" }, {
          pattern: /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/,
          message: "请输入正确的身份证号",
          trigger: "blur"
        }],
        email: [{
          required: true,
          message: "邮箱不能为空",
          trigger: "blur" }, {
          pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: "请输入正确的邮箱",
          trigger: "blur"
        }],
        addr: [{
          required: true,
          message: "地址不能为空",
          trigger: "blur" }]
      },
      options: _elementChinaAreaData.regionData,
      selectedOptions: [],
      page: {
        pageSize: _api.PageSize,
        criteria: ""
      }
    };
  },

  methods: {
    loadData: function loadData() {
      var _this = this;

      this.page.criteria = sessionStorage.getItem("loginName");
      (0, _api.RequestGet)("/customer/getCustomerList", this.page).then(function (response) {
        if (response.code == "0000") {
          _this.form = response.data[0];
          _this.total = response.page.totalCount;
          _this.totalsize = response.page.pageSize;
        }
      }).catch(function (error) {
        _this.$router.push({ path: "/login" });
      });
    },
    onSubmit: function onSubmit(form) {
      var _this2 = this;

      this.$refs[form].validate(function (valid) {
        if (valid) {
          (0, _api.RequestPost)("/customer/update", _this2.form).then(function (response) {
            if (response.code == "0000") {
              _this2.$message({
                message: response.message,
                type: "success"
              });
              _this2.loadData();
            } else {
              _this2.$message({
                message: response.message,
                type: "error"
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleChange: function handleChange() {}
  },

  created: function created() {
    this.loadData();
  }
};

/***/ })

},[1255]);


// WEBPACK FOOTER //
// static/js/app.bc6464adfad1565a47a8.js